import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import Main from '@modules/main/Main';
// import Login from "./modules/login/login";
import UserRegistration from "./Rujul/Admin/Security/registration/UserRegisterationAdd";
import AwardMaster from "./modules/master/AwardMaster/AwardMaster";
import DomainMaster from "./modules/master/DomainMaster/DomainMaster";
import JobMaster from "./modules/master/JobMaster/JobMaster";
import CourseMaster from "./modules/master/CourseMaster/CourseMaster";
import CurrencyMaster from "./modules/master/CurrencyMaster/CurrencyMaster";
import CurrencyMasterForm from "./modules/master/CurrencyMaster/CurrencyMasterForm";
import SkillMaster from "./modules/master/SkillMaster/SkillMaster";
import LocationMaster from "./modules/master/LocationMaster/LocationMaster";
import Demosform from "./modules/master/LocationMaster/LocationMaster";
import EmployeeHistorylist from "./Rujul/EmployeeHistory/EmployeeHistorylist";
import EmployeeHistoryEdit from "./Rujul/EmployeeHistory/EmployeeHistoryEdit";
import PMQuestionMaster from "./modules/HR/PMQuestionMaster/PMQuestionMaster";
import ClientMaster from "./modules/master/ClientMaster/ClientMaster";
import ClientMasterForm from "./modules/master/ClientMaster/ClientMasterForm";
import IncentiveMaster from "./modules/master/IncentiveMaster/IncentiveMaster";
import TechnologyMaster from "./modules/master/TechnologyMaster/TechnologyMaster";
import ReferCandidatelist from "./modules/HR/RecrtProcess/ReferCandidate/ReferCandidateList";
import HrInterviews from "./modules/HR/RecrtProcess/HRInterviews/HRInterviews";
//Recruitment Process
import AddCandidate from "./modules/HR/RecrtProcess/candidate/add-candidate";
import EditCandidate from "./modules/HR/RecrtProcess/candidate/edit-candidate";
import CandidateInProcess from "./modules/HR/RecrtProcess/candidate/CandidateinProcess";
import OfferLetter from "./modules/HR/RecrtProcess/SendOfferLetter/SendOfferLetter";
import OfferAcceptOrReject from "./modules/external/offer-accept-reject";
import AddFeedback from "./modules/HR/RecrtProcess/AddFeedback/AddFeedback";
import BirthdayCard from "./modules/HR/RecrtProcess/BirthdayCard/BirthdayCard";
import EditBirthdayCard from "./modules/HR/RecrtProcess/BirthdayCard/EditBirthdayCard";
// import LeaveForm from "./Admin/LeaveManagement/Leave/LeaveForm";
import LeaveList from "./Rujul/HRM/LeaveManagement/Leave/LeaveList";
// import PerformanceEvaluationReport from "./modules/HR/PRForm/PerformanceEvaluationReport";
import FeedbackSubmitted from "./modules/HR/RecrtProcess/AddFeedback/SubmittedFeedback";
import CandidateDetails from "./modules/external/candidate-details/CandidateDetails";
// import Register from '@modules/register/Register';
// import ForgetPassword from '@modules/forgot-password/ForgotPassword';
// import RecoverPassword from '@modules/recover-password/RecoverPassword';
// import { useWindowSize } from './hooks/useWindowSize';
import { calculateWindowSize } from "./utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
// import { setWindowSize } from './store/reducers/ui';

// import Dashboard from '@pages/Dashboard';
// import Blank from '@pages/Blank';
// import SubMenu from '@pages/SubMenu';
// import Profile from '@pages/profile/Profile';

import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import ExternalRoute from "./routes/ExtenalRoute";
import { setAuthentication } from "./store/reducers/auth";
import "./App.css";
import {
  // GoogleProvider,
  getAuthStatus,
  // getFacebookLoginStatus,
} from "./utils/oidc-providers";

import Postjobform from "./modules/HR/RecrtProcess/PostAJob/Postjobform";
import AddForm from "./modules/master/CourseMaster/CourseMasterForm";
import AddNewApplication from "./modules/HR/RecrtProcess/New-Application/AddNewApplication";
import EditNewApplication from "./modules/HR/RecrtProcess/New-Application/EditNewApplication";
import ScheduleInterviewList from "./modules/HR/RecrtProcess/Schedule-Interview/ScheduleInterview";
import ScheduleInterviewForm from "./modules/HR/RecrtProcess/Schedule-Interview/ScheduleInterviewForm";
import ReferCandidateList from "./modules/HR/RecrtProcess/ReferCandidate/ReferCandidateList";
import ReferCandidateForm from "./modules/HR/RecrtProcess/ReferCandidate/ReferCandidate";
import FeedbackMaster from "./modules/HR/RecrtProcess/FeedbackMaster/Feedbackmaster";
import FeedbackForm from "./modules/HR/RecrtProcess/FeedbackMaster/FeedbackMasterform";
import CandidateHistory from "./modules/HR/RecrtProcess/candidate-history/CandidateHistoryState";
import CandidateHistoryView from "./modules/HR/RecrtProcess/candidate-history/CandidateHistroyView";
import HrAuthority from "./modules/HR/RecrtProcess/HRAuthority/index";
import ScheduleInterviewViewPage from "./modules/HR/RecrtProcess/Schedule-Interview/ScheduleInterviewViewPage";
import ThankYou from "./modules/external/thankyou";
import FeedbackLinkExpire from "./modules/HR/RecrtProcess/AddFeedback/FeedbackLinkExpire";
import CandidateIntrList from "./modules/HR/RecrtProcess/Reports/CandidateIntrList";
import CandidateintrList from "./modules/HR/RecrtProcess/Reports/CandidateIntrList";
import ReferCandidateStatus from "./modules/HR/RecrtProcess/Reports/ReferCandidateStatus";
import OfferReport from "./modules/HR/RecrtProcess/Reports/OfferReport";
import HRReports from "./modules/HR/RecrtProcess/Reports/HRReports";
import RequisitionTrackerReport from "./modules/HR/RecrtProcess/Reports/RequisitionTrackerReport";
import InterviewStatusReport from "./modules/HR/RecrtProcess/Reports/InterviewStatusReport";
import InterviewerReport from "./modules/HR/RecrtProcess/Reports/InterviewerReport";
import WeeklyJoiner from "./modules/HR/RecrtProcess/Reports/WeeklyJoiner";
//Performance Review
import PrQuestionMaster from "./modules/HR/PRForm/PR_Ques_Master/PrQuestionMaster";
import PR_Appraisal from "./modules/HR/PRForm/PR_Appraisal_Master/PR_Appraisal";
import PR_Temp from "./modules/HR/PRForm/PR_Temp_Master/PR_Temp";
import MyPerformanceEvaluationReport from "./modules/HR/PRForm/PerformanceReview_Report/MyPerformanceEvaluationReport";
import TeamPerformanceEvaluationReport from "./modules/HR/PRForm/TeamPerformanceEvaluationReport";
import PRScoreReport from "./modules/HR/PRForm/PRScoreReport";
import PerformanceEvaluationReport from "./modules/HR/PRForm/PerformanceEvaluationReport/PerformanceEvaluationReport";
import PerformanceEvalRepSubjective from "./modules/HR/PRForm/PerformanceEvalRepSubjective";
import PerformanceEvaluations from "./modules/HR/PRForm/PerformanceEvaluations/PerformanceEvaluations";
import PR_Status from "./modules/HR/PRForm/PRStatusReport/PR_Status";
import ViewFeedback from "./modules/HR/RecrtProcess/AddFeedback/ViewFeedBack";
import NotFoundPage from "./modules/error/not_found";
// Admin/Rujual
import CompanyMaster from "./Rujul/Admin/Organization/Company/CompanyMaster";
import CompanyMasterTable from "./Rujul/Admin/Organization/Company/CompanyMasterTable";
import EditCompanyMaster from "./Rujul/Admin/Organization/Company/EditCompanyMaster";
import BranchMaster from "./Rujul/Admin/Organization/Branch/BranchMaster";
import BranchMasterTable from "./Rujul/Admin/Organization/Branch/BranchMasterTable";
import EditBranchMaster from "./Rujul/Admin/Organization/Branch/EditBranchMaster";
import Anniversary from "./modules/HR/RecrtProcess/AnniversaryRemainder/AnniversaryRemainderlist";
import HRPolicies from "./modules/HR/RecrtProcess/HR Policy/HRPolicies";
import ManagerRemark from "./modules/HR/RecrtProcess/AnniversaryRemainder/ManagerRemark";
import EmployeeRemark from "./modules/HR/RecrtProcess/AnniversaryRemainder/EmployeeRemark";
import Holiday from "./Rujul/HRM/Organization/Holiday/Holiday";
import Shift from "./Rujul/HRM/Organization/Shift/Shift";
import HRCalenderForm from "./Rujul/HRM/Organization/HRcalender/HRCalenderForm";
import HRCalender from "./Rujul/HRM/Organization/HRcalender/HRCalender";
import Department from "./Rujul/HRM/Organization/Department/Department";
import Designation from "./Rujul/HRM/Organization/Designation/Designation";
// import EditHRCalender from "./Admin/Rujual/HRcalender/EditHRCalender";
import Area from "./Rujul/Admin/General/Area/Area";
import CalenderEdit from "./Rujul/HRM/Organization/HRcalender/CalenderEdit";
import RevenueByResource from "./modules/ROM/RomReport/RevenueByResource";

// import SideBar from './components/SideBar';
// import Navbar from './components/Navbar';

// import Navbar from './components/Navbar';

// const { VITE_NODE_ENV } = import.meta.env;
// rom-report
import BenchTrackerReport from "./modules/ROM/RomReport/BenchTrackerReport";
import OnBenchProjectReport from "./modules/ROM/RomReport/OnBenchProjectReport";
import DueExtensionReport from "./modules/ROM/RomReport/DueExtensionReport";
import MasterReport from "./modules/ROM/RomReport/MasterReport";
import CustomerContactReport from "./modules/ROM/RomReport/CustomerContactReport";
import SkillSetMatrixReport from "./modules/ROM/RomReport/SkillSetMatrixReport";
import ResourceReport from "./modules/ROM/RomReport/ResourceReport";
import EditCustomerRequirement from "./modules/ROM/CustomerRequirement/EditCustomerRequirement";
import ListOfContractor from "./modules/ROM/PartnerManagement/contractors/ListOfContractor";
import PartnerMaster from "./modules/ROM/PartnerManagement/partnerMaster/PartnerMaster";
import CreatePartnerMaster from "./modules/ROM/PartnerManagement/partnerMaster/CreatePartnerMaster";
import AddCustomerRequirement from "./modules/ROM/CustomerRequirement/AddCustomerRequirement";
import AddContractor from "./modules/ROM/PartnerManagement/contractors/AddContractor";
import Currentopportunity from "./modules/ROM/CurrentOpportunity/Currentopportunity";
// import ROMInterviewStatusReport from "./modules/ROM/RomInterviewStatusReports/RomInterviewStatusReports";
import CustomerRequirement from "./modules/ROM/CustomerRequirement/CustomerRequirement";
import EditContractor from "./modules/ROM/PartnerManagement/contractors/EditContractor";
import RomInterviewStatusReports from "./modules/ROM/RomInterviewStatusReports/RomInterviewStatusReports";
import EmployeesSelection from "./modules/ROM/CustomerRequirement/employeeSelection/EmployeesSelection";
import AmendmentLog from "./modules/ROM/CustomerRequirement/AmendmentLog";
import ViewJobDescription from "./modules/HR/RecrtProcess/AddFeedback/ViewJobDescription";
import EmployeeList from "./Rujul/HRM/Organization//Employee/EmployeeList";
import AttendanceStatus from "./Rujul/HRM/Organization/AttendanceStatus/AttendanceStatus";

import ThankYouPageCandidate from "./modules/external/candidate-details/CandidateDetailsSubmitted";
import LinkExpired from "./modules/external/candidate-details/LinkExpired";
import BankList from "./Rujul/Admin/Bank/banklist";
import LeaveStatement from "./Rujul/HRM/LeaveManagement/LeaveStatement/LeaveStatement";
import AddBank from "./Rujul/Admin/Bank/add";
import VerifyCandidateDetails from "./Rujul/HRM/Organization//Employee/VerifyCandidateDetails";
import TAVerifyCandidateDetails from "./Rujul/HRM/Organization//Employee/TAVerifyCandidateDetails";
import LeaveForm from "./Rujul/HRM/LeaveManagement/Leave/LeaveForm";
// import LeaveList from "./Admin/LeaveManagement/Leave/LeaveList";
import EditLeaveForm from "./Rujul/HRM/LeaveManagement/Leave/EditLeaveForm";
import LeaveSummary from "./Rujul/HRM/LeaveManagement/LeaveSummary/LeaveSummary";
import AllProjects from "./modules/Project-Management/Project/AllProjects/AllProjects";
import LeaveLedger from "./Rujul/HRM/LeaveManagement/LeaveLedger/LeaveLedger";
import CreateProject from "./modules/Project-Management/Project/CreateProject/CreateProject";
import CreateProjectAdd from "./modules/Project-Management/Project/CreateProject/CreateProjectAdd";
import ApplyLeave from "./modules/TimeSheet/Leave/ApplyLeave/ApplyLeave";
import EditApplyLeave from "./modules/TimeSheet/Leave/ApplyLeave/EditApplyLeave";
import EmployeeLeaveSummary from "./modules/TimeSheet/Leave/ApplyLeave/EmployeeLeaveSummary";
import ApproveLeave from "./modules/TimeSheet/Leave/ApproveLeave/ApproveLeave";
import ViewLeaveDetails from "./modules/TimeSheet/Leave/ApproveLeave/ViewLeaveDetails";
import TeamLeaveStatusReport from "./modules/TimeSheet/Leave/TeamLeaveStatusReport/TeamLeaveStatusReport";
import LeaveHistoryReport from "./modules/TimeSheet/Leave/LeaveHistoryReport/LeaveHistoryReport";
import ApplyCompOff from "./modules/TimeSheet/CompOff/ApplyCompOff";
import EditCompOff from "./modules/TimeSheet/CompOff/EditCompOff";
import ViewCompOff from "./modules/TimeSheet/CompOff/ViewCompOff";
import ApprovalCompOff from "./modules/TimeSheet/CompOff/ApprovalCompOff";
import CompOffHistroryReport from "./modules/TimeSheet/CompOff/CompOffHistroryReport";
import CompOffStatement from "./modules/TimeSheet/CompOff/CompOffStatement";
import Dashboard from "./modules/Dashboard/Dashboard";
import RoleList from "./Rujul/Admin/Security/Roles";
import AddRole from "./Rujul/Admin/Security/Roles/add";
import EditRole from "./Rujul/Admin/Security/Roles/edit";
import MaternityLeave from "./Rujul/HRM/LeaveManagement/MaternityLeave/MaternityLeave";
import AttendanceApproval from "./modules/TimeSheet/Attendance/AttendanceCalender/AttendanceApproval";
import AttendanceStatement from "./modules//TimeSheet/Attendance/AttendanceCalender/AttendanceStatement";
import KpiReport from "./modules/ROM/RomReport/Kpi-Report/KpiReport";
import EmployeeCost from "./modules/ROM/RomReport/EmployeeCost";
import NonBillableemployee from "./modules/ROM/RomReport/NonBillableemployee";
import CreatePartnerMasterEdit from "./modules/ROM/PartnerManagement/partnerMaster/CreatePartnerMasterEdit";
import HolidayCalender from "./Rujul/HRM/Organization/HolidayCalender/HolidayCalender";
import EmployeeDetailsReport from "./modules/Organization/employeeDetailsReport/EmployeeDetailsReport";
import OrganizationChart from "./modules/Organization/orgChart/OrganizationChart";
import Announcements from "./modules/Organization/announcements/Announcements";
import MonthlyReport from "./modules/Organization/MonthlyReport/MonthlyReport";
import KpiSummary from "./modules/ROM/RomReport/KpiSummary";
import CourseMasterForm from "./modules/master/CourseMaster/CourseMasterForm";
import SkillMasterForm from "./modules/master/SkillMaster/SkillMasterForm";
import AddPRTemplate from "./modules/HR/PRForm/PR_Temp_Master/AddPRTemplate";
import EditPrTemplate from "./modules/HR/PRForm/PR_Temp_Master/EditPrTemplate";
import Add_PR_Appraisal from "./modules/HR/PRForm/PR_Appraisal_Master/Add_PR_Appraisal";
import Edit_PR_Appraisal from "./modules/HR/PRForm/PR_Appraisal_Master/Edit_PR_Appraisal";
import ViewPerformanceEvaluationReport from "./modules/HR/PRForm/Component/ViewPerformanceEvaluationReport";
import ViewPRStatus from "./modules/HR/PRForm/PRStatusReport/ViewPRStatus";
import PeriodicReport from "./modules/HR/RecrtProcess/Reports/PeriodicReport";
import FulfillmentReport from "./modules/HR/RecrtProcess/Reports/FulfillmentReport";
import ViewTempMaster from "./modules/HR/PRForm/PR_Temp_Master/ViewTempMaster";

import AssetCategory from "./modules/Support-Desk/IT-Master/AssetCategory/AssetCategory";
import ModelMasters from "./modules/Support-Desk/IT-Master/ModelMasters/ModelMasters";
import AssetCategoryForm from "./modules/Support-Desk/IT-Master/AssetCategory/AssetCategoryForm";
import VendorMasterList from "./modules/Support-Desk/IT-Master/VendorMaster/VendorMasterList";
import VendorMasterAdd from "./modules/Support-Desk/IT-Master/VendorMaster/VendorMasterAdd";
import VendorMasterEdit from "./modules/Support-Desk/IT-Master/VendorMaster/VendorMasterEdit";
import AssetReturnList from "./modules/Support-Desk/Procurement/AssetReturn/AssetReturnList";
import AssetReturnAdd from "./modules/Support-Desk/Procurement/AssetReturn/AssetReturnAdd";
import ModelMasterAdd from "./modules/Support-Desk/IT-Master/ModelMasters/ModelMasterAdd";
import ModelMasterEdit from "./modules/Support-Desk/IT-Master/ModelMasters/ModelMasterEdit";
import DisposedOfAssetReport from "./modules/Support-Desk/Procurement/DisposedOfAssetReport/DisposedOfAssetReport";
import SummaryReportITReport from "./modules/Support-Desk/AssetReports/SummaryReportITReport";
import AssetAllocationList from "./modules/Support-Desk/Procurement/AssetAllocation/AssetAllocationList";
import AssetAllocationAdd from "./modules/Support-Desk/Procurement/AssetAllocation/AssetAllocationAdd";
import RepairableAssetsList from "./modules/Support-Desk/AssetReports/RepairableAssets/RepairableAssetsList";
import RepairableAssetAdd from "./modules/Support-Desk/AssetReports/RepairableAssets/RepairableAssetAdd";
import RepairableAssetEdit from "./modules/Support-Desk/AssetReports/RepairableAssets/RepairableAssetEdit";
import MasterReportITAssets from "./modules/Support-Desk/AssetReports/MasterReportITAssets";
import ObsoleteAssets from "./modules/Support-Desk/AssetReports/ObsoleteAssets";
import PurchaseSummary from "./modules/Support-Desk/AssetReports/PurchaseSummary";
import SubscriptionSummary from "./modules/Support-Desk/AssetReports/SubscriptionSummary";
import AssetReturnStatement from "./modules/Support-Desk/AssetReports/AssetReturnStatement";
import AssetAllocationDetails from "./modules/Support-Desk/AssetReports/AssetAllocationDetails";
import AddAssetList from "./modules/Support-Desk/Procurement/AddAssets/AddAssetList";
import AddAssetForm from "./modules/Support-Desk/Procurement/AddAssets/AddAssetForm";
import EditAssetForm from "./modules/Support-Desk/Procurement/AddAssets/EditAssetForm";
import AssetHistory from "./modules/Support-Desk/Procurement/AddAssets/AssetHistory";
import EmployeeAdminList from "./modules/Support-Desk/Requisition/HR-Admin/EmployeeAdminList";
import EmployeeAdminAddForm from "./modules/Support-Desk/Requisition/HR-Admin/EmployeeAdminAddForm";
import EmployeeAdminEditForm from "./modules/Support-Desk/Requisition/HR-Admin/EmployeeAdminEditForm";
import SuperAdminList from "./modules/Support-Desk/Requisition/HR-Admin/SuperAdminList";
import PostJob from "./modules/HR/RecrtProcess/PostAJob/PostJob";
import TeamPerformanceEvaluation from "./modules/HR/PRForm/PerformanceEvaluations/TeamPerformanceEvaluation";
import ContractorsFee from "./modules/Payroll/Contractors Fee/ContractorsFee";
import ExpenseAdvanceReport from "./modules/Payroll/Reimbursements/Expense Advance Report/ExpenseAdvanceReport";
import MyReimbursementss from "./modules/Payroll/Reimbursements/My Reimbursements/MyReimbursements";
import AllReimbursements from "./modules/Payroll/Reimbursements/All Reimbursements/AllReimbursements";
import MyTrainingIncentive from "./modules/Payroll/Earnings/My Training Incentive/MyTrainingIncentive";
import LeaveEncashmentReport from "./modules/Payroll/LeaveEncashmentReport/LeaveEncashmentReport";
import RequisitionApproval from "./modules/Support-Desk/Requisition/RequisitionApproval";
import TnE from "./modules/Payroll/Reimbursements/New TnE/TnE/TnE";
import ExpenseAdvanceList from "./modules/Payroll/Reimbursements/ExpenseAdvance/ExpenseAdvanceList";
import ExpenseAdvanceForm from "./modules/Payroll/Reimbursements/ExpenseAdvance/ExpenseAdvanceForm";
import NiceMaster from "./modules/Payroll/Nice Master Report/NiceMaster";
import SuperITSupportTicketList from "./modules/Support-Desk/Requisition/IT-Support-Ticket/SuperITSupportTicketList";
import EmployeeITSupportTicketAddForm from "./modules/Support-Desk/Requisition/IT-Support-Ticket/EmployeeITSupportTicketAddForm";
import EmployeeITSupportTicketList from "./modules/Support-Desk/Requisition/IT-Support-Ticket/EmployeeITSupportTicketList";
import EmployeeITSupportTicketEditForm from "./modules/Support-Desk/Requisition/IT-Support-Ticket/EmployeeITSupportTicketEditForm";
import TeamReimbursements from "./modules/Payroll/Reimbursements/Team Reimbursements/TeamReimbursements";
import EmployeeTaxRegime from "./modules/Payroll/Reimbursements/Finance/EmployeeTaxRegime/EmployeeTaxRegime";
import ExpenseAdvanceEdit from "./modules/Payroll/Reimbursements/ExpenseAdvance/ExpenseAdvanceEdit";
import MyPayroll from "./modules/Payroll/Earnings/My Payroll/MyPayroll";
import TeamPayroll from "./modules/Payroll/Earnings/Team Payroll/TeamPayroll";
import ReimbursementApproval from "./modules/Payroll/Reimbursements/Team Reimbursements/ReimbursementApproval";
import ExportTE from "./modules/Payroll/Reimbursements/All Reimbursements/ExportT&E";
import ViewTnE from "./modules/Payroll/Reimbursements/My Reimbursements/ViewTnE";
import TnEEdit from "./modules/Payroll/Reimbursements/My Reimbursements/TnEEdit";
import AssetAllocationEdit from "./modules/Support-Desk/Procurement/AssetAllocation/AssetAllocationEdit";
import EmployeeCTCReport from "./modules/Payroll/Employee CTC Report/EmployeeCTCReport";
import EmployeeComponent from "./modules/Payroll/Employee Component/EmployeeComponent";
import IncentiveCCA from "./modules/Payroll/Incentive & CCA/Incentive/CCA/IncentiveCCA";
import IncentiveCCAApproval from "./modules/Payroll/Incentive & CCA/Incentive & CCA Approval/IncentiveCCAApproval";
import UserList from "./Rujul/Admin/Security/registration/UserList";
import IncentiveCCAStatement from "./modules/Payroll/Incentive & CCA/Incentive and CCA Statement/IncentiveCCAStatement";
import LeaveEncashment from "./modules/Payroll/Leave Encashment/LeaveEncashment";
import LeaveEncashmentEdit from "./modules/Payroll/Leave Encashment/LeaveEncashmentEdit";
import EmployeeTaxRegimeAdd from "./modules/Payroll/Reimbursements/Finance/EmployeeTaxRegime/EmployeeTaxRegimeAdd";
import EmployeeTaxRegimeEdit from "./modules/Payroll/Reimbursements/Finance/EmployeeTaxRegime/EmployeeTaxRegimeEdit";
import EmployeeEarningReport from "./modules/Payroll/Employee Earning Report/EmployeeEarningReport";
import MyComponent from "./modules/Payroll/MyComponent/MyComponent";
import MyIncrementComponent from "./modules/Payroll/MyIncrementComponents/MyIncreamentComponent";
import UserRegisterationEdit from "./Rujul/Admin/Security/registration/UserRegisterationEdit";
import PayrollListing from "./Rujul/HRM/PayrollManagement/Payroll/PayrollListing";
import PayrollAdd from "./Rujul/HRM/PayrollManagement/Payroll/PayrollAdd";
import PayrollEdit from "./Rujul/HRM/PayrollManagement/Payroll/PayrollEdit";
import PayrollScalesList from "./Rujul/HRM/PayrollManagement/PayrollScales/PayrollScalesList";
import PayrollScalesAdd from "./Rujul/HRM/PayrollManagement/PayrollScales/PayrollScalesAdd";
import PayrollScalesEdit from "./Rujul/HRM/PayrollManagement/PayrollScales/PayrollScalesEdit";
import ITDeclarationList from "./Rujul/HRM/PayrollManagement/ITDeclaration/ITDeclarationList";
import ITDeclarationAdd from "./Rujul/HRM/PayrollManagement/ITDeclaration/ITDeclarationAdd";
import ITDeclarationEdit from "./Rujul/HRM/PayrollManagement/ITDeclaration/ITDeclarationEdit";
import ImportAsset from "./modules/Support-Desk/Procurement/AddAssets/ImportAsset";
import EmployeeITDeclarations from "./Rujul/HRM/PayrollManagement/EmployeeITDeclaration/EmployeeITDeclarations";
import EmployeePayrollIncrement from "./Rujul/HRM/PayrollManagement/EmployeePayrollIncrement/EmployeePayrollIncrement";
import GeneralMaster from "./Rujul/Admin/General/GeneralMaster/GeneralMaster";
import GeneralMasterAdd from "./Rujul/Admin/General/GeneralMaster/GeneralMasterAdd";
import GeneralMasterEdit from "./Rujul/Admin/General/GeneralMaster/GeneralMasterEdit";
import GeneralMasterView from "./Rujul/Admin/General/GeneralMaster/GeneralMasterView";
import ObjectTypeList from "./Rujul/Admin/Settings/ObjectType/ObjectTypeList";
import ObjectType from "./Rujul/Admin/Settings/ObjectType/ObjectType";
import ObjectTypeEdit from "./Rujul/Admin/Settings/ObjectType/ObjectTypeEdit";
import CalculatePayroll from "./Rujul/HRM/PayrollManagement/CalculatePayroll/CalculatePayroll";
import ConfirmationPayroll from "./Rujul/HRM/PayrollManagement/ConfirmationPayroll/ConfirmationPayroll";
import AttendanceBookRujul from "./Rujul/HRM/TimeSheet/Attendance-Book/AttendanceBookRujul";
import AttendanceRegister from "./Rujul/HRM/TimeSheet/Attendance-Book-Approval/AttendanceBookApproval";
import AttendanceBookApproval from "./Rujul/HRM/TimeSheet/Attendance-Book-Approval/AttendanceBookApproval";
import MyPaySlip from "./modules/Payroll/Earnings/My-PaySlip/MyPaySlip";
import Navbar from "../src/components/Navbar";
import PrintEmailPaySlip from "./Rujul/HRM/PayrollManagement/PrintEmailPaySlip/PrintEmailPaySlip";
import GeneratePayrollAdvice from "./Rujul/HRM/PayrollManagement/GeneratePayrollAdvice/GeneratePayrollAdvice";
import MyTDSCertificate from "./modules/Payroll/Earnings/MyTdsCertificate/MyTDSCertificate";
import EmployeeAdd from "./Rujul/Employee/EmployeeAdd";
import EmployeePayrolls from "./Rujul/HRM/Organization/Employee/EmployeePayrolls/EmployeePayrolls";
import CreateProjectEdit from "./modules/Project-Management/Project/CreateProject/CreateProjectEdit";
import EmployeeEdit from "./Rujul/Employee/EmployeeEdit";
import InvoiceList from "./modules/Project-Management/List/InvoiceList";
import AddBirthdayCard from "./modules/HR/RecrtProcess/BirthdayCard/AddBirthdayCard";
import AttendanceBookStatement from "./Rujul/HRM/TimeSheet/Attendance-Book-statement/AttendanceBookStatement";
import ForthComing from "./modules/Dashboard/ForthComing/ForthComing";
import Whatsnew from "./modules/Dashboard/WhatNew/Whatsnew";
import Achievers from "./modules/Dashboard/Achievers/Achievers";
import EmployeeMasterReport from "./modules/ROM/RomReport/EmployeeMasterReport";
import TAReport from "./modules/ROM/TAReport/TAReport";
import InvoiceReportConsultingContent from "./modules/Project-Management/Reports/InvoiceReportConsultingContent";
import EmployeeProfile from "./modules/Dashboard/Employee_Profile/EmployeeProfile";
import CreateProjectAmendmentLog from "./modules/Project-Management/Project/CreateProject/CreateProjectAmendmentLog";
import AwardForm from "./modules/Organization/award/AwardForm";
import AwardEditForm from "./modules/Organization/award/AwardEditForm";
import AwardList from "./modules/Organization/award/AwardList";
import KnowledgeBase from "./modules/Organization/Knowledge-Base/KnowledgeBase";
import KnowledgeBaseAdmin from "./modules/Organization/Knowledge-Base-Admin/KnowledgeBaseAdmin";
import PostWhatsNewForthcoming from "./modules/Organization/PostWhatsNew-Forthcoming/PostWhatsNewForthcoming";
import IncomeTaxSlabList from "./Rujul/HRM/PayrollManagement/IncomeTaxSlab/IncomeTaxSlabList";
import IncomeTaxSlabAdd from "./Rujul/HRM/PayrollManagement/IncomeTaxSlab/IncomeTaxSlabAdd";
import PaymentSlip from "./Rujul/HRM/PayrollManagement/PrintEmailPaySlip/PaymentSlip";
import ResourceAllocation from "./modules/Project-Management/Project/Resource/ResourceAllocation/ResourceAllocation";
import ProjectStatusReport from "./modules/Project-Management/Project/ProjectStatusReport/ProjectStatusReport";
import MyProject from "./modules/Project-Management/Project/MyProject/MyProject";
import AchieversLeaderBoard from "./modules/Dashboard/Achievers/AchieversLeaderBoard";
import ExpenseSettlementStatement from "./modules/Payroll/Reimbursements/ExpenseSettlementStatement/ExpenseSettlementStatement";
import AssetCategoryFormEdit from "./modules/Support-Desk/IT-Master/AssetCategory/AssetCategoryForm";
import CurrentJobOpening from "./modules/Dashboard/CurrentJobOpening/CurrentJobOpening";
import MyResource from "./modules/Project-Management/Project/Resource/MyResource/MyResource";
import TrainingCalender from "./modules/Project-Management/Training/Training_Calender/TrainingCalender";
import MyTraining from "./modules/Project-Management/Training/MyTraining/MyTraining";
// import MyResource from "./modules/Project-Management/Project/Resource/MyResource/MyResource";
import MyTaskIndex from "./modules/Project-Management/Task/My-Task/MyTaskIndex";
import MyTaskAdd from "./modules/Project-Management/Task/My-Task/MyTaskAdd";
import MyTaskEdit from "./modules/Project-Management/Task/My-Task/MyTaskEdit";
import MyTeamTask from "./modules/Project-Management/Task/My-Team-Task/MyTeamTask";
import AllocateTaskList from "./modules/Project-Management/Task/Task-Allocation/AllocateTaskList";
import AllocateTaskAdd from "./modules/Project-Management/Task/Task-Allocation/AllocateTaskAdd";
import AllocateTaskEdit from "./modules/Project-Management/Task/Task-Allocation/AllocateTaskEdit";
import ApproveTraining from "./modules/Project-Management/Training/ApproveTraining/ApproveTraining";
import MyTeamTrainingIncentive from "./modules/Project-Management/Training/MyTeamTrainingIncentive/MyTeamTrainingIncentive";
import TrainingIncentive from "./modules/Project-Management/Training/TrainingIncentive/TrainingIncentive";
import AddTrainingIncentive from "./modules/Project-Management/Training/TrainingIncentive/AddTrainingIncentive";
import EditTrainingIncentive from "./modules/Project-Management/Training/TrainingIncentive/EditTrainingIncentive";
import InvoiceListTraining from "./modules/Project-Management/List/InvoiceList(Training)/InvoiceListTraining";
import TnEInvoiveListTraining from "./modules/Project-Management/List/TnEInvoiceList(Training)/TnEInvoiveListTraining";
import InvoiceReportTraining from "./modules/Project-Management/Reports/InvoiveReport(Training)/InvoiceReportTraining";
import AllReport from "./modules/Project-Management/Reports/AllReport/AllReport";
import AllInvoiceReport from "./modules/Project-Management/Reports/AllInvoiceReport/AllInvoiceReport";
import TneInvoiceReportConsultingContent from "./modules/Project-Management/Reports/TnEInvoiceReportConsultingContent/TneInvoiceReportConsultingContent";
import TneInvoiceReportTraining from "./modules/Project-Management/Reports/TnEInvoiceReport(Training)/TneInvoiceReportTraining";
import TrainingApprovalLead from "./modules/Project-Management/Training/TrainingApprovalLead/TrainingApprovalLead";
import PayrollStatement from "./Rujul/HRM/PayrollManagement/PayrollStatement/PayrollStatement";
import EmployeeView from "./Rujul/Employee/EmployeeView";
import ChangePassword from "./modules/login/ResetPassword";
import LeaveApproves from "./modules/HR/RecrtProcess/Reports/LeaveApproves";
import RMGKPIEmpList from "./modules/ROM/KPIPages/RMGKPIEmpList";
import RMGEmployeeView from "./modules/ROM/KPIPages/RMGEmployeeView";
import RMGSubcontractorList from "./modules/ROM/KPIPages/RMGSubcontractorList";
import ScheduleInterviewEditPage from "./modules/HR/RecrtProcess/Schedule-Interview/ScheduleInterviewEditPage";
import HRAttendanceApproval from "./modules/TimeSheet/Attendance/AttendanceCalender/HRAttendanceApproval";
import UpcomingJoineer from "./modules/Support-Desk/UpcomingJoineer/UpcomingJoineer";
import ApplySPLeave from "./modules/TimeSheet/PL-ML-BL/ApplySPLeave";
import EditSPLeave from "./modules/TimeSheet/PL-ML-BL/EditSPLeave";
import ApproveSPLeave from "./modules/TimeSheet/PL-ML-BL/ApproveSPLeave";
import VIewSPLeave from "./modules/TimeSheet/PL-ML-BL/VIewSPLeave";
import CompanyFinancialMonth from "./Rujul/HRM/PayrollManagement/CompanyFinancialMonth/CompanyFinancialMonth";
// import TneInvoiceList_ConsultingContent from "./modules/Project-Management/List/TnE-Invoice-List(Consulting&Content)/TneInvoiceList_ConsultingContent";
import TnEInvoiceListCNC from "./modules/Project-Management/List/TnEInvoiceListCNC/TnEInvoiceListCNC";
import IncomeTaxSlabEdit from "./Rujul/HRM/PayrollManagement/IncomeTaxSlab/IncomeTaxSlabEdit";
import OfferLetterListing from "./modules/HR/RecrtProcess/OfferLetterListing/OfferLetterListing";
import EmpFeedBackForm from "./modules/HR/EmpFeedBackForm/EmpFeedBackForm";
import ProjectEvalFeedbackForm from "./modules/HR/ProjectEvalFeedbackForm/ProjectEvalFeedbackForm";
import ProjectEvalFeedbacklist from "./modules/HR/ProjectEvalFeedbackForm/ProjectEvalFeedbacklist";
import KnowledgeSharing from "./modules/Dashboard/KnowledgeSharing/KnowledgeSharing";
import ResumeParser from "./modules/HR/RecrtProcess/ResumeParser/ResumeParser";
import ResumeParserEdit from "./modules/HR/RecrtProcess/ResumeParser/ResumeParserEdit";
import CategoryDesignationForm from "./modules/HR/PRForm/PR_MasterReport/PR_Category_Question_Weightage_Master/CategoryDesignationForm";
import PRCategoryDesignation from "./modules/HR/PRForm/PR_MasterReport/PR_Category_Question_Weightage_Master/PRCategory";
import PRDesignationCategory from "./modules/HR/PRForm/PR_MasterReport/PR_Designation_Grouping/DesignationGrouping";
import PRCategory from "./modules/HR/PRForm/PR_MasterReport/PR_MasterReportListing/PRReport";
import ViewDesignationCategory from "./modules/HR/PRForm/PR_MasterReport/PR_Category_Question_Weightage_Master/ViewCategoryDesignationForm";
import ProtectedRoute from "./components/NavBarMenu/ProtectedRoute";
import AnnualBonusReport from "./modules/HR/PRForm/PerformanceEvaluationReport/AnnualBonusReport";
import AnnualApprasialReport from "./modules/HR/PRForm/PerformanceEvaluationReport/AnnualAppraisalReport";
import FinancialWorkingReport from "./modules/HR/PRForm/PerformanceEvaluationReport/FinancialWorkingReport";
import RequisitionResource from "./modules/ROM/RequisitionResource/RequisitionResourceListing";
import AddRequisitionResource from "./modules/ROM/RequisitionResource/AddRequisitionResource";
import ViewTeamPRDetails from "./modules/HR/PRForm/Component/ViewTeamPRDetails";
import AssetMaintenanceListing from "./modules/Support-Desk/Procurement/AssetMaintenance/AssetMaintenanceListing";

const App = ({ isSidebarOpen }) => {
  // const windowSize = useWindowSize();
  // const screenSize = useSelector((state) => state.ui.screenSize);
  const dispatch = useDispatch();
  const location = useLocation();

  const [isAppLoading, setIsAppLoading] = useState(true);
  const [username, setUsername] = useState("");
  
  const heading = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  const checkSession = async () => {
    try {
      let responses = await Promise.all([getAuthStatus()]);

      responses = responses.filter((r) => Boolean(r));

      if (responses && responses.length > 0) {
        dispatch(setAuthentication(responses[0]));
      }
    } catch (error) {
      console.error("error", error);
    }
    setIsAppLoading(false);
  };

  useEffect(() => {
    checkSession();
  }, []);

  // if (isAppLoading) {
  //   return (
  //     <p class="position-absolute top-50 start-50 translate-middle text-center">
  //       <FaSpinner class="spinner" />
  //       <br />
  //       Loading
  //     </p>
  //   );
  // }

  return (
    <>
    <ProtectedRoute>
      <Routes>
        {/* Public routes */}
        {/* <Route path="/login" element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route> */}
        <Route path="/" element={<PrivateRoute />}>
          <Route
            path="/"
            element={<Dashboard isSidebarOpen={isSidebarOpen} />}
          />
        </Route>
        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route
            path="/dashboard"
            element={<Dashboard isSidebarOpen={isSidebarOpen} />}
          />
        </Route>
        <Route path="/employee-profile/:id" element={<PrivateRoute />}>
          <Route path="/employee-profile/:id" element={<EmployeeProfile />} />
        </Route>
        <Route path="/forthcoming" element={<PrivateRoute />}>
          <Route path="/forthcoming" element={<ForthComing />} />
        </Route>
        <Route path="/whatsnew" element={<PrivateRoute />}>
          <Route path="/whatsnew" element={<Whatsnew />} />
        </Route>
        <Route path="/achievers" element={<PrivateRoute />}>
          <Route path="/achievers" element={<Achievers />} />
        </Route>
          <Route path="/knowledge-sharing" element={<PrivateRoute />}>
          <Route
            path="/knowledge-sharing"
            element={<KnowledgeSharing />}
          />
        </Route>
        <Route path="/change-password" element={<PrivateRoute />}>
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>
        <Route path="/achievers/leaderboard" element={<PrivateRoute />}>
          <Route
            path="/achievers/leaderboard"
            element={<AchieversLeaderBoard />}
          />
        </Route>
        {/* Page Navigate without ID  */}
        <Route path="/dashboard/current-job-opening" element={<PrivateRoute />}>
          <Route
            path="/dashboard/current-job-opening"
            element={<CurrentJobOpening />}
          />
        </Route>
        {/* Page Navigate with ID  */}
        <Route
          path="/dashboard/current-job-opening/:profileID"
          element={<PrivateRoute />}
        >
          <Route
            path="/dashboard/current-job-opening/:profileID"
            element={<CurrentJobOpening />}
          />
        </Route>

        <Route path="/hr-attendance-approval" element={<PrivateRoute />}>
          <Route
            path="/hr-attendance-approval"
            element={<HRAttendanceApproval />}
          />
        </Route>
        <Route path="/attendance-approval" element={<PrivateRoute />}>
          <Route path="/attendance-approval" element={<AttendanceApproval />} />
        </Route>
        <Route path="/attendance-statement" element={<PrivateRoute />}>
          <Route
            path="/attendance-statement"
            element={<AttendanceStatement />}
          />
        </Route>
        <Route
          path="/50881180195049806954114046419509/:emp_id/:emp_name"
          element={<PrivateRoute />}
        >
          <Route
            path="/50881180195049806954114046419509/:emp_id/:emp_name"
            element={<EditBirthdayCard />}
          />
        </Route>
        {/* <Route path="/offer-accepted" element={<ExternalRoute />}>
          <Route path="/offer-accepted" element={<ThankYou />} />
        </Route> */}

        <Route path="/award-master" element={<PrivateRoute />}>
          <Route path="/award-master" element={<AwardMaster />} />
        </Route>
        <Route path="/domain-master" element={<PrivateRoute />}>
          <Route path="/domain-master" element={<DomainMaster />} />{" "}
        </Route>
        <Route path="/job-master" element={<PrivateRoute />}>
          <Route path="/job-master" element={<JobMaster />} />
        </Route>
        <Route path="/course-master" element={<PrivateRoute />}>
          <Route path="/course-master" element={<CourseMaster />} />
        </Route>
        <Route path="/course-master/add" element={<PrivateRoute />}>
          <Route path="/course-master/add" element={<CourseMasterForm />} />
        </Route>
        <Route path="/course-master/add/:id" element={<PrivateRoute />}>
          <Route path="/course-master/add/:id" element={<CourseMasterForm />} />
        </Route>
        <Route path="/currency-master" element={<PrivateRoute />}>
          <Route path="/currency-master" element={<CurrencyMaster />} />
        </Route>
        <Route path="/currency-master/add" element={<PrivateRoute />}>
          <Route path="/currency-master/add" element={<CurrencyMasterForm />} />
        </Route>
        <Route path="/currency-master/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/currency-master/edit/:id"
            element={<CurrencyMasterForm />}
          />
        </Route>
        <Route path="/currency-master/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/currency-master/edit/:id"
            element={<CurrencyMasterForm />}
          />{" "}
          {/** Not develop **/}
        </Route>
        <Route path="/currencymaster" element={<PrivateRoute />}>
          <Route path="/currencymaster" element={<CurrencyMaster />} />{" "}
          {/** Not develop **/}
        </Route>
        <Route path="/skill-master" element={<PrivateRoute />}>
          <Route path="/skill-master" element={<SkillMaster />} />
        </Route>
        <Route path="/skill-master/add" element={<PrivateRoute />}>
          <Route path="/skill-master/add" element={<SkillMasterForm />} />
        </Route>
        <Route path="/skill-master/add/:id" element={<PrivateRoute />}>
          <Route path="/skill-master/add/:id" element={<SkillMasterForm />} />
        </Route>
        <Route path="/location-master" element={<PrivateRoute />}>
          <Route path="/location-master" element={<LocationMaster />} />
        </Route>
        <Route path="/client-master" element={<PrivateRoute />}>
          <Route path="/client-master" element={<ClientMaster />} />
        </Route>
        <Route path="/client-master/add" element={<PrivateRoute />}>
          <Route path="/client-master/add" element={<ClientMasterForm />} />
        </Route>
        <Route path="/client-master/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/client-master/edit/:id"
            element={<ClientMasterForm />}
          />
        </Route>
        <Route path="/incentive-master" element={<PrivateRoute />}>
          <Route path="/incentive-master" element={<IncentiveMaster />} />{" "}
          {/** Some issue need to resolve**/}
        </Route>
        <Route path="/technology-master" element={<PrivateRoute />}>
          <Route path="/technology-master" element={<TechnologyMaster />} />
        </Route>
        <Route path="/resume-parser" element={<PrivateRoute />}>
          <Route path="/resume-parser" element={<ResumeParser />} />
        </Route>
        <Route path="/resume-parser/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/resume-parser/edit/:id"
            element={<ResumeParserEdit />}
          />
        </Route>
        <Route path="/postjob" element={<PrivateRoute />}>
          <Route path="/postjob" element={<PostJob />} />
        </Route>
        <Route path="/postjob/add" element={<PrivateRoute />}>
          <Route path="/postjob/add" element={<Postjobform />} />
        </Route>
        <Route path="/postjob/Edit/:id" element={<PrivateRoute />}>
          <Route path="/postjob/Edit/:id" element={<Postjobform />} />
        </Route>
        <Route path="/refer-candidate" element={<PrivateRoute />}>
          <Route path="/refer-candidate" element={<ReferCandidatelist />} />
        </Route>
        <Route path="/refer-candidate/add" element={<PrivateRoute />}>
          <Route path="/refer-candidate/add" element={<ReferCandidateForm />} />
        </Route>
        <Route path="/refer-candidate/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/refer-candidate/edit/:id"
            element={<ReferCandidateForm />}
          />
        </Route>
        <Route path="/hrinterviews" element={<PrivateRoute />}>
          <Route path="/hrinterviews" element={<HrInterviews />} />
        </Route>
        <Route path="/add-candidate/:id" element={<PrivateRoute />}>
          <Route path="/add-candidate/:id" element={<AddCandidate />} />
        </Route>
        <Route
          path="/candidate-in-process/candidate/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/candidate-in-process/candidate/edit/:id"
            element={<EditCandidate />}
          />
        </Route>
        <Route path="/candidate-in-process" element={<PrivateRoute />}>
          <Route
            path="/candidate-in-process"
            element={<CandidateInProcess />}
          />
        </Route>
        <Route path="/hr-authority" element={<PrivateRoute />}>
          <Route path="/hr-authority" element={<HrAuthority />} />
        </Route>
        {/* <Route path="/new-application/:id" element={<PrivateRoute />}>
      <Route path="/new-application/:id" element={<NewApplication />} />
    </Route> */}
        <Route
          path="/postjob/new-application/:id/:job_master_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/postjob/new-application/:id/:job_master_id"
            element={<AddNewApplication />}
          />
        </Route>
        <Route
          path="/hrinterviews/new-application/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/hrinterviews/new-application/edit/:id"
            element={<EditNewApplication />}
          />
        </Route>
        <Route path="/schedule-interview-list" element={<PrivateRoute />}>
          <Route
            path="/schedule-interview-list"
            element={<ScheduleInterviewList />}
          />
        </Route>
        <Route
          path="/schedule-interview-list/view-interview/:interview_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/schedule-interview-list/view-interview/:interview_id"
            element={<ScheduleInterviewViewPage />}
          />
        </Route>
        <Route
          path="/schedule-interview-list/edit-interview/:edit_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/schedule-interview-list/edit-interview/:edit_id"
            element={<ScheduleInterviewEditPage />}
          />
        </Route>
        <Route
          path="/candidate-in-process/schedule-interview/:candidate_id/:job_description_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/candidate-in-process/schedule-interview/:candidate_id/:job_description_id"
            element={<ScheduleInterviewForm />}
          />
        </Route>
        <Route
          path="/candidate-in-process/hr-authority/:candidate_id/:job_description_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/candidate-in-process/hr-authority/:candidate_id/:job_description_id"
            element={<HrAuthority />}
          />
        </Route>
        <Route path="/feedback-master" element={<PrivateRoute />}>
          <Route path="/feedback-master" element={<FeedbackMaster />} />
        </Route>
        <Route path="/feedback-master/add" element={<PrivateRoute />}>
          <Route path="/feedback-master/add" element={<FeedbackForm />} />
        </Route>
        <Route path="/feedback-master/edit/:id" element={<PrivateRoute />}>
          <Route path="/feedback-master/edit/:id" element={<FeedbackForm />} />
        </Route>
        <Route path="/candidate-history" element={<PrivateRoute />}>
          <Route path="/candidate-history" element={<CandidateHistory />} />
        </Route>
        <Route path="/candidate-history/view/:id" element={<PrivateRoute />}>
          <Route
            path="/candidate-history/view/:id"
            element={<CandidateHistoryView />}
          />
        </Route>
        <Route
          path="/candidate-in-process/offer-letter/:candidate_id/:job_description_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/candidate-in-process/offer-letter/:candidate_id/:job_description_id"
            element={<OfferLetter />}
          />
        </Route>
        <Route
          path="/addfeedback/:interview_id/:feedback_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/addfeedback/:interview_id/:feedback_id"
            element={<AddFeedback />}
          />
        </Route>
        <Route path="/offer-letter-listing" element={<PrivateRoute />}>
          <Route path="/offer-letter-listing" element={<OfferLetterListing />} />
        </Route>
        <Route path="/feedback-link-expire" element={<PrivateRoute />}>
          <Route
            path="/feedback-link-expire"
            element={<FeedbackLinkExpire />}
          />
        </Route>
        <Route path="/view-feedbacks/:candidate_id" element={<PrivateRoute />}>
          <Route
            path="/view-feedbacks/:candidate_id"
            element={<ViewFeedback />}
          />
        </Route>
        <Route path="/candidate-interview-list" element={<PrivateRoute />}>
          <Route
            path="/candidate-interview-list"
            element={<CandidateIntrList />}
          />
        </Route>
        <Route path="/my-refercandidate-status" element={<PrivateRoute />}>
          <Route
            path="/my-refercandidate-status"
            element={<ReferCandidateStatus />}
          />
        </Route>
        <Route path="/candidate-interview-list" element={<PrivateRoute />}>
          <Route
            path="/candidate-interview-list"
            element={<CandidateintrList />}
          />
        </Route>
        <Route path="/offer-report" element={<PrivateRoute />}>
          <Route path="/offer-report" element={<OfferReport />} />
        </Route>
        <Route path="/hr-report" element={<PrivateRoute />}>
          <Route path="/hr-report" element={<HRReports />} />
        </Route>
        <Route path="/fulfillment-report" element={<PrivateRoute />}>
          <Route path="/fulfillment-report" element={<FulfillmentReport />} />
        </Route>
        <Route path="/requisition-tracker-report" element={<PrivateRoute />}>
          <Route path="/requisition-tracker-report" element={<RequisitionTrackerReport />} />
        </Route>
        <Route path="/interview-status-report" element={<PrivateRoute />}>
          <Route
            path="/interview-status-report"
            element={<InterviewStatusReport />}
          />
        </Route>
        <Route path="/interviewer-report" element={<PrivateRoute />}>
          <Route path="/interviewer-report" element={<InterviewerReport />} />
        </Route>
        <Route path="/weeklyjoiner-report" element={<PrivateRoute />}>
          <Route path="/weeklyjoiner-report" element={<WeeklyJoiner />} />
        </Route>
        <Route path="/periodic-report" element={<PrivateRoute />}>
          <Route path="/periodic-report" element={<PeriodicReport />} />
        </Route>
        {/* Not Done Report Start */}
        {/* <Route path="/team-evaluation-report" element={<PrivateRoute />}>
          <Route
            path="/team-evaluation-report"
            element={<TeamPerformanceEvaluationReport />}
          />
        </Route> */}
        <Route path="/evaluation-report" element={<PrivateRoute />}>
          <Route
            path="/evaluation-report"
            element={<PerformanceEvaluationReport />}
          />
        </Route>
        <Route path="/pr-score-report" element={<PrivateRoute />}>
          <Route path="/pr-score-report" element={<PRScoreReport />} />
        </Route>
        {/* <Route path="/subjectivepereval-report" element={<PrivateRoute />}>
          <Route
            path="/subjectivepereval-report"
            element={<PerformanceEvalRepSubjective />}
          />
        </Route> */}
        {/* Not Done Report End */}
        {/** Pr Forms Start */}
        <Route path="/question-masters" element={<PrivateRoute />}>
          <Route path="/question-masters" element={<PrQuestionMaster />} />
        </Route>
        <Route path="/pm/question-masters" element={<PrivateRoute />}>
          <Route path="/pm/question-masters" element={<PMQuestionMaster />} />
        </Route>
        <Route path="/employee/feedback-form/:id" element={<PrivateRoute />}>
          <Route path="/employee/feedback-form/:id" element={<EmpFeedBackForm />} />
        </Route>
        <Route path="/employee/feedback/view/:id" element={<PrivateRoute />}>
          <Route path="/employee/feedback/view/:id" element={<ProjectEvalFeedbackForm />} />
        </Route>
        <Route path="/employee/feedback" element={<PrivateRoute />}>
          <Route path="/employee/feedback" element={<ProjectEvalFeedbacklist />} />
        </Route>
        <Route path="/appraisal-template-masters" element={<PrivateRoute />}>
          <Route path="/appraisal-template-masters" element={<PR_Temp />} />
        </Route>
        <Route
          path="/appraisal-template-masters/add"
          element={<PrivateRoute />}
        >
          <Route
            path="/appraisal-template-masters/add"
            element={<AddPRTemplate />}
          />
        </Route>
        <Route
          path="/appraisal-template-masters/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/appraisal-template-masters/edit/:id"
            element={<EditPrTemplate />}
          />
        </Route>
        <Route
          path="/appraisal-template-masters/view/:id/:type"
          element={<PrivateRoute />}
        >
          <Route
            path="/appraisal-template-masters/view/:id/:type"
            element={<EditPrTemplate />}
          />
        </Route>
        <Route path="/appraisal-cycles" element={<PrivateRoute />}>
          <Route path="/appraisal-cycles" element={<PR_Appraisal />} />
        </Route>
        <Route path="/appraisal-cycles/add" element={<PrivateRoute />}>
          <Route path="/appraisal-cycles/add" element={<Add_PR_Appraisal />} />
        </Route>
        <Route path="/appraisal-cycles/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/appraisal-cycles/edit/:id"
            element={<Edit_PR_Appraisal />}
          />
        </Route>
        <Route path="/pr-evaluation-report" element={<PrivateRoute />}>
          <Route
            path="/pr-evaluation-report"
            element={<PerformanceEvaluationReport />}
          />
        </Route>
        <Route path="/pr-evaluation-report/:id" element={<PrivateRoute />}>
          <Route
            path="/pr-evaluation-report/:id"
            element={<ViewPerformanceEvaluationReport />}
          />
        </Route>
        <Route path="/pr-status" element={<PrivateRoute />}>
          <Route path="/pr-status" element={<PR_Status />} />
        </Route>
        <Route path="/view-pr-status/:id" element={<PrivateRoute />}>
          <Route path="/view-pr-status/:id" element={<ViewPRStatus />} />
        </Route>
        {/** Main Form route */}
        <Route path="/team-evaluation-report" element={<PrivateRoute />}>
          <Route
            path="/team-evaluation-report"
            element={<TeamPerformanceEvaluationReport />}
          />
        </Route>
        <Route path="/team-evaluation-report/:id" element={<PrivateRoute />}>
          <Route
            path="/team-evaluation-report/:id"
            element={<ViewTeamPRDetails />}
          />
        </Route>
        <Route path="/prscore-report" element={<PrivateRoute />}>
          <Route path="/prscore-report" element={<PRScoreReport />} />
        </Route>
        <Route
          path="/my-performance-evaluation-report"
          element={<PrivateRoute />}
        >
          <Route
            path="/my-performance-evaluation-report"
            element={<MyPerformanceEvaluationReport />}
          />
        </Route>
        <Route
          path="/appraisal-template-masters/view/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/appraisal-template-masters/view/:id"
            element={<ViewTempMaster />}
          />
        </Route>
        <Route
          path="/pr-subjective-evaluation-report"
          element={<PrivateRoute />}
        >
          <Route
            path="/pr-subjective-evaluation-report"
            element={<PerformanceEvalRepSubjective />}
          />
        </Route>
        <Route path="/performance-evaluations" element={<PrivateRoute />}>
          <Route
            path="/performance-evaluations"
            element={<PerformanceEvaluations />}
          />
        </Route>
        <Route path="/team-performance-evaluations" element={<PrivateRoute />}>
          <Route
            path="/team-performance-evaluations"
            element={<TeamPerformanceEvaluation />}
          />
        </Route>
        {/* <Route path="/pr_status" element={<PrivateRoute />}>
          <Route path="/pr_status" element={<PR_Status />} />
        </Route> */}
        <Route path="/notfound" element={<ExternalRoute />}>
          <Route path="/notfound" element={<NotFoundPage />} />
        </Route>
        {/* Pr Forms End */}
        {/* ROM Route */}
        <Route path="/partner-master" element={<PrivateRoute />}>
          <Route path="/partner-master" element={<PartnerMaster />} />
        </Route>
         <Route path="/pr-master-report" element={<PrivateRoute />}>
          <Route path="/pr-master-report" element={<PRCategory />} />
        </Route>
         <Route path="/category-designation/view/:categoryId/:questionId" element={<PrivateRoute />}>
          <Route
            path="/category-designation/view/:categoryId/:questionId"
            element={<ViewDesignationCategory />}
          />
        </Route>
        <Route path="/partner-master/add" element={<PrivateRoute />}>
          <Route path="/partner-master/add" element={<CreatePartnerMaster />} />
        </Route>
        <Route path="/partner-master/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/partner-master/edit/:id"
            element={<CreatePartnerMasterEdit />}
          />
        </Route>
        <Route path="/contractors" element={<PrivateRoute />}>
          <Route path="/contractors" element={<ListOfContractor />} />
        </Route>
        <Route path="/contractors/add" element={<PrivateRoute />}>
          <Route path="/contractors/add" element={<AddContractor />} />
        </Route>
        <Route path="/contractors/add/:id" element={<PrivateRoute />}>
          <Route path="/contractors/add/:id" element={<AddContractor />} />
        </Route>
        <Route path="/current-opportunities" element={<PrivateRoute />}>
          <Route
            path="/current-opportunities"
            element={<Currentopportunity />}
          />
        </Route>
        <Route
          path="/customer-requirement/employee-selection"
          element={<PrivateRoute />}
        >
          <Route
            path="/customer-requirement/employee-selection"
            element={<PrivateRoute />}
          >
            <Route
              path="/customer-requirement/employee-selection/:id/:skill_id"
              element={<EmployeesSelection />}
            />
            <Route
              path="/customer-requirement/employee-selection/:id/:skill_id"
              element={<EmployeesSelection />}
            />
          </Route>
        </Route>
        <Route path="/rom/interview-status-reports" element={<PrivateRoute />}>
          <Route
            path="/rom/interview-status-reports"
            element={<RomInterviewStatusReports />}
          />
        </Route>
        <Route
          path="/rom/interview-status-reports/:ReqId"
          element={<PrivateRoute />}
        >
          <Route
            path="/rom/interview-status-reports/:ReqId"
            element={<RomInterviewStatusReports />}
          />
        </Route>
        <Route path="/contractors/edit" element={<PrivateRoute />}>
          <Route path="/contractors/edit" element={<EditContractor />} />
        </Route>
        <Route path="/contractors/edit/:id" element={<PrivateRoute />}>
          <Route path="/contractors/edit/:id" element={<EditContractor />} />
        </Route>
        <Route path="/customer-requirement" element={<PrivateRoute />}>
          <Route
            path="/customer-requirement"
            element={<CustomerRequirement />}
          />
        </Route>
        <Route path="/customer-requirement/add" element={<PrivateRoute />}>
          <Route
            path="/customer-requirement/add"
            element={<AddCustomerRequirement />}
          />
        </Route>
        <Route path="/customer-requirement/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/customer-requirement/edit/:id"
            element={<EditCustomerRequirement />}
          />
        </Route>
        <Route
          path="/customer-requirement/edit/:id/:EmployeeID"
          element={<PrivateRoute />}
        >
          <Route
            path="/customer-requirement/edit/:id/:EmployeeID"
            element={<EditCustomerRequirement />}
          />
        </Route>
        <Route
          path="/customer-requirement/amendment-log"
          element={<PrivateRoute />}
        >
          <Route
            path="/customer-requirement/amendment-log"
            element={<AmendmentLog />}
          />
        </Route>
        <Route
          path="/customer-requirement/amendment-log/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/customer-requirement/amendment-log/:id"
            element={<AmendmentLog />}
          />
        </Route>
        {/* Requisition Resource */}
        <Route path="/requisition-resource-listing" element={<PrivateRoute />}>
          <Route
            path="/requisition-resource-listing"
            element={<RequisitionResource />}
          />
        </Route>
        <Route path="/add-requisition-resource" element={<PrivateRoute />}>
          <Route
            path="/add-requisition-resource"
            element={<AddRequisitionResource />}
          />
        </Route>
        {/** Project Management */}
        <Route path="/all-projects" element={<PrivateRoute />}>
          <Route path="/all-projects" element={<AllProjects />} />
        </Route>
        <Route path="/create-project" element={<PrivateRoute />}>
          <Route path="/create-project" element={<CreateProject />} />
        </Route>
        <Route path="/create-project/add" element={<PrivateRoute />}>
          <Route path="/create-project/add" element={<CreateProjectAdd />} />
        </Route>
        <Route path="/create-project/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/create-project/edit/:id"
            element={<CreateProjectEdit />}
          />
        </Route>
        <Route
          path="/create-project/amendment_log/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/create-project/amendment_log/:id"
            element={<CreateProjectAmendmentLog />}
          />
        </Route>
        <Route path="/project-invoice-list" element={<PrivateRoute />}>
          <Route path="/project-invoice-list" element={<InvoiceList />} />
        </Route>
        <Route path="/projects/tne/invoices" element={<PrivateRoute />}>
          <Route path="/projects/tne/invoices" element={<TnEInvoiceListCNC />} />
        </Route>
        <Route
          path="/project-invoice-report/consulting-content"
          element={<PrivateRoute />}
        >
          <Route
            path="/project-invoice-report/consulting-content"
            element={<InvoiceReportConsultingContent />}
          />
        </Route>
        {/* Project */}
        <Route path="/project-status-report" element={<PrivateRoute />}>
          <Route
            path="/project-status-report"
            element={<ProjectStatusReport />}
          />
        </Route>
        <Route path="/my-project" element={<PrivateRoute />}>
          <Route path="/my-project" element={<MyProject />} />
        </Route>
        <Route path="/my-task" element={<PrivateRoute />}>
          <Route path="/my-task" element={<MyTaskIndex />} />
        </Route>
        <Route path="/my-task/add" element={<PrivateRoute />}>
          <Route path="/my-task/add" element={<MyTaskAdd />} />
        </Route>
        <Route path="/my-task/edit/:id" element={<PrivateRoute />}>
          <Route path="/my-task/edit/:id" element={<MyTaskEdit />} />
        </Route>
        <Route path="/my-team-task" element={<PrivateRoute />}>
          <Route path="/my-team-task" element={<MyTeamTask />} />
        </Route>
        <Route path="/allocate-task" element={<PrivateRoute />}>
          <Route path="/allocate-task" element={<AllocateTaskList />} />
        </Route>
        <Route path="/allocate-task/add" element={<PrivateRoute />}>
          <Route path="/allocate-task/add" element={<AllocateTaskAdd />} />
        </Route>
        <Route path="/allocate-task/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/allocate-task/edit/:id"
            element={<AllocateTaskEdit />}
          />
        </Route>
        {/* Resource Allocation */}
        <Route path="/resource-allocation" element={<PrivateRoute />}>
          <Route path="/resource-allocation" element={<ResourceAllocation />} />
        </Route>
        <Route path="/my-resource" element={<PrivateRoute />}>
          <Route path="/my-resource" element={<MyResource />} />
        </Route>
        {/* Training Calender */}
        <Route path="/training-calender" element={<PrivateRoute />}>
          <Route path="/training-calender" element={<TrainingCalender />} />
        </Route>
        {/* My Training */}
        <Route path="/my-training" element={<PrivateRoute />}>
          <Route path="/my-training" element={<MyTraining />} />
        </Route>
        {/* Approve Training */}
        <Route path="/approve-training" element={<PrivateRoute />}>
          <Route path="/approve-training" element={<ApproveTraining />} />
        </Route>
        {/* My Team Training Incentive */}
        <Route path="/my-team-training-incentive" element={<PrivateRoute />}>
          <Route
            path="/my-team-training-incentive"
            element={<MyTeamTrainingIncentive />}
          />
        </Route>
        {/* Training Incentive */}
        <Route path="/training-incentive" element={<PrivateRoute />}>
          <Route path="/training-incentive" element={<TrainingIncentive />} />
        </Route>
        <Route path="/training-incentive/add" element={<PrivateRoute />}>
          <Route
            path="/training-incentive/add"
            element={<AddTrainingIncentive />}
          />
        </Route>
        <Route path="/training-incentive/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/training-incentive/edit/:id"
            element={<EditTrainingIncentive />}
          />
        </Route>
        {/* Invoive List (Training) */}
        <Route path="/invoice-list-training" element={<PrivateRoute />}>
          <Route
            path="/invoice-list-training"
            element={<InvoiceListTraining />}
          />
        </Route>
        <Route path="/training-approval-lead" element={<PrivateRoute />}>
          <Route
            path="/training-approval-lead"
            element={<TrainingApprovalLead />}
          />
        </Route>
        {/* Tne Invoice Training */}
        <Route path="/tne-invoivelist-training" element={<PrivateRoute />}>
          <Route
            path="/tne-invoivelist-training"
            element={<TnEInvoiveListTraining />}
          />
        </Route>
        {/* Invoice Training Report  */}
        <Route
          path="/report/invoice-report-training"
          element={<PrivateRoute />}
        >
          <Route
            path="/report/invoice-report-training"
            element={<InvoiceReportTraining />}
          />
        </Route>
        {/* All Report */}
        <Route path="/report/all-report" element={<PrivateRoute />}>
          <Route path="/report/all-report" element={<AllReport />} />
        </Route>
        {/* All Invoice Report */}
        <Route path="/report/all-invoice-report" element={<PrivateRoute />}>
          <Route
            path="/report/all-invoice-report"
            element={<AllInvoiceReport />}
          />
        </Route>
        {/* TnE Invoice Report Consulting and Content */}
        <Route path="/report/tne-invoice-report" element={<PrivateRoute />}>
          <Route
            path="/report/tne-invoice-report"
            element={<TneInvoiceReportConsultingContent />}
          />
        </Route>
        {/* TnE Invoice Report (Training) */}
        <Route
          path="/report/tne-invoice-report-training"
          element={<PrivateRoute />}
        >
          <Route
            path="/report/tne-invoice-report-training"
            element={<TneInvoiceReportTraining />}
          />
        </Route>
        {/* Birthday*/}
        <Route path="/birthday-card" element={<PrivateRoute />}>
          <Route path="/birthday-card" element={<BirthdayCard />} />
        </Route>
        <Route path="/birthday-card/add" element={<PrivateRoute />}>
          <Route path="/birthday-card/add" element={<AddBirthdayCard />} />
        </Route>
        {/* Admin/Rujual */}
        <Route path="/company-master" element={<PrivateRoute />}>
          <Route path="/company-master" element={<CompanyMasterTable />} />
        </Route>
        <Route path="/company-master/add" element={<PrivateRoute />}>
          <Route path="/company-master/add" element={<CompanyMaster />} />
        </Route>
        <Route path="/company-master/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/company-master/edit/:id"
            element={<EditCompanyMaster />}
          />
        </Route>
        <Route path="/branch-master/add" element={<PrivateRoute />}>
          <Route path="/branch-master/add" element={<BranchMaster />} />
        </Route>
        <Route path="/editbranchmaster/:id" element={<PrivateRoute />}>
          <Route path="/editbranchmaster/:id" element={<EditBranchMaster />} />
        </Route>
        <Route path="/branchmastertable" element={<PrivateRoute />}>
          <Route path="/branchmastertable" element={<BranchMasterTable />} />
        </Route>
        <Route path="/holiday" element={<PrivateRoute />}>
          <Route path="/holiday" element={<Holiday />} />
        </Route>
        <Route path="/shift" element={<PrivateRoute />}>
          <Route path="/shift" element={<Shift />} />
        </Route>
        <Route path="/department" element={<PrivateRoute />}>
          <Route path="/department" element={<Department />} />
        </Route>
        <Route path="/designation" element={<PrivateRoute />}>
          <Route path="/designation" element={<Designation />} />
        </Route>
        <Route path="/area-master" element={<PrivateRoute />}>
          <Route path="/area-master" element={<Area />} />
        </Route>
        <Route path="/attendanceStatus" element={<PrivateRoute />}>
          <Route path="/attendanceStatus" element={<AttendanceStatus />} />
        </Route>
        {/* Leave Statement */}
        <Route path="/leaveStatement" element={<PrivateRoute />}>
          <Route path="/leaveStatement" element={<LeaveStatement />} />
        </Route>
        {/* leave summary */}
        <Route path="/leaveSummary" element={<PrivateRoute />}>
          <Route path="/leaveSummary" element={<LeaveSummary />} />
        </Route>
        {/* Leave list and Form */}
        <Route path="/apply/special-leave" element={<PrivateRoute />}>
          <Route path="/apply/special-leave" element={<ApplySPLeave />} />
        </Route>
        <Route path="/special-leave/edit/:id" element={<PrivateRoute />}>
          <Route path="/special-leave/edit/:id" element={<EditSPLeave />} />
        </Route>
        <Route path="/approve/special-leave" element={<PrivateRoute />}>
          <Route path="/approve/special-leave" element={<ApproveSPLeave />} />
        </Route>
        <Route path="/special-leave/view/:id" element={<PrivateRoute />}>
          <Route path="/special-leave/view/:id" element={<VIewSPLeave />} />
        </Route>
        <Route path="/apply-leave" element={<PrivateRoute />}>
          <Route path="/apply-leave" element={<ApplyLeave />} />
        </Route>
        <Route path="/apply-leave/edit" element={<PrivateRoute />}>
          <Route path="/apply-leave/edit" element={<EditApplyLeave />} />
        </Route>
        <Route path="/apply-leave/edit/:id" element={<PrivateRoute />}>
          <Route path="/apply-leave/edit/:id" element={<EditApplyLeave />} />
        </Route>
        <Route path="/approve-leave" element={<PrivateRoute />}>
          <Route path="/approve-leave" element={<ApproveLeave />} />
        </Route>

        <Route
          path="/approve-leave/leave-report/emp/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/approve-leave/leave-report/emp/:id"
            element={<ViewLeaveDetails />}
          />
        </Route>
        <Route path="/leave-list/add" element={<PrivateRoute />}>
          <Route path="/leave-list/add" element={<LeaveForm />} />
        </Route>
        <Route path="/leave-list" element={<PrivateRoute />}>
          <Route path="/leave-list" element={<LeaveList />} />
        </Route>
        <Route path="/leave-list/edit/:id" element={<PrivateRoute />}>
          <Route path="/leave-list/edit/:id" element={<EditLeaveForm />} />
        </Route>
        <Route path="/emp-leave-summary" element={<PrivateRoute />}>
          <Route path="/emp-leave-summary" element={<EmployeeLeaveSummary />} />
        </Route>
        <Route path="/team-leave-status-report" element={<PrivateRoute />}>
          <Route
            path="/team-leave-status-report"
            element={<TeamLeaveStatusReport />}
          />
        </Route>
        <Route path="/leave-history-report" element={<PrivateRoute />}>
          <Route
            path="/leave-history-report"
            element={<LeaveHistoryReport />}
          />
        </Route>
        {/* Payroll section start */}
        {/* Contractors Fee section */}
        <Route path="/contractors-fee" element={<PrivateRoute />}>
          <Route path="/contractors-fee" element={<ContractorsFee />} />
        </Route>
        {/* Expense Advance Report section */}
        <Route path="/expense-advance-report" element={<PrivateRoute />}>
          <Route
            path="/expense-advance-report"
            element={<ExpenseAdvanceReport />}
          />
        </Route>
        {/* My Reimbursements */}
        <Route path="/my-reimbursements/report" element={<PrivateRoute />}>
          <Route
            path="/my-reimbursements/report"
            element={<MyReimbursementss />}
          />
        </Route>
        {/* All Reimbursements */}
        <Route path="/all-reimbursements" element={<PrivateRoute />}>
          <Route path="/all-reimbursements" element={<AllReimbursements />} />
        </Route>
        <Route path="/new-tne/view/:id" element={<PrivateRoute />}>
          <Route path="/new-tne/view/:id" element={<ViewTnE />} />
        </Route>
        <Route
          path="/my-reimbursements/report/exportTne/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/my-reimbursements/report/exportTne/:id"
            element={<ExportTE />}
          />
        </Route>
        {/* My Training Incentive */}
        <Route path="/my-training-incentives" element={<PrivateRoute />}>
          <Route
            path="/my-training-incentives"
            element={<MyTrainingIncentive />}
          />
        </Route>
        {/* Leave Encashment Report */}
        <Route path="/leave-encashment-report" element={<PrivateRoute />}>
          <Route
            path="/leave-encashment-report"
            element={<LeaveEncashmentReport />}
          />
        </Route>
        {/* Leave Encashment */}
        <Route path="/leave-encashment" element={<PrivateRoute />}>
          <Route path="/leave-encashment" element={<LeaveEncashment />} />
        </Route>
        <Route path="/leave-encashment/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/leave-encashment/edit/:id"
            element={<LeaveEncashmentEdit />}
          />
        </Route>
        {/* TnE Section */}
        <Route path="/new-tne" element={<PrivateRoute />}>
          <Route path="/new-tne" element={<TnE />} />
        </Route>
        <Route path="/new-tne/edit/:id" element={<PrivateRoute />}>
          <Route path="/new-tne/edit/:id" element={<TnEEdit />} />
        </Route>
        {/* Expense Advance */}
        <Route path="/expense-advance" element={<PrivateRoute />}>
          <Route path="/expense-advance" element={<ExpenseAdvanceList />} />
        </Route>
        <Route path="/expense-advance/add" element={<PrivateRoute />}>
          <Route path="/expense-advance/add" element={<ExpenseAdvanceForm />} />
        </Route>
        <Route path="/expense-advance/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/expense-advance/edit/:id"
            element={<ExpenseAdvanceEdit />}
          />
        </Route>
        {/* Nice Master Report section */}
        <Route path="/nice-master-report" element={<PrivateRoute />}>
          <Route path="/nice-master-report" element={<NiceMaster />} />
        </Route>
        {/* Team Reimbursements */}
        <Route path="/team-reimbursements" element={<PrivateRoute />}>
          <Route path="/team-reimbursements" element={<TeamReimbursements />} />
        </Route>
        <Route
          path="/team-reimbursements/approval/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/team-reimbursements/approval/:id"
            element={<ReimbursementApproval />}
          />
        </Route>
        {/* Employee Tax Regime */}
        <Route path="/employee-tax-regime" element={<PrivateRoute />}>
          <Route path="/employee-tax-regime" element={<EmployeeTaxRegime />} />
        </Route>
        <Route path="/employee-tax-regime/add" element={<PrivateRoute />}>
          <Route
            path="/employee-tax-regime/add"
            element={<EmployeeTaxRegimeAdd />}
          />
        </Route>
        <Route path="/employee-tax-regime/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/employee-tax-regime/edit/:id"
            element={<EmployeeTaxRegimeEdit />}
          />
        </Route>
        {/* My Payroll section */}
        <Route path="/my-payroll" element={<PrivateRoute />}>
          <Route path="/my-payroll" element={<MyPayroll />} />
        </Route>
        {/* Team Payroll section */}
        <Route path="/team-payroll" element={<PrivateRoute />}>
          <Route path="/team-payroll" element={<TeamPayroll />} />
        </Route>
        <Route path="/user/pay-slip" element={<PrivateRoute />}>
          <Route path="/user/pay-slip" element={<MyPaySlip />} />
        </Route>
        <Route path="/user/pay-slip/:id" element={<PrivateRoute />}>
          <Route path="/user/pay-slip/:id" element={<MyPaySlip />} />
        </Route>
        {/* Employee CTC Report section */}
        <Route path="/employee-ctc-report" element={<PrivateRoute />}>
          <Route path="/employee-ctc-report" element={<EmployeeCTCReport />} />
        </Route>
        {/* Annual Bonus Report section */}
        <Route path="/annual-bonus-report" element={<PrivateRoute />}>
          <Route path="/annual-bonus-report" element={<AnnualBonusReport />} />
        </Route>
        {/* Annual Appraisal Report section */}
        <Route path="/annual-appraisal-report" element={<PrivateRoute />}>
          <Route path="/annual-appraisal-report" element={<AnnualApprasialReport />} />
        </Route>
         {/* Final Working  Report section */}
        <Route path="/annual-finance-report" element={<PrivateRoute />}>
          <Route path="/annual-finance-report" element={<FinancialWorkingReport />} />
        </Route>
        {/* Employee Component section */}
        <Route path="/employee-component" element={<PrivateRoute />}>
          <Route path="/employee-component" element={<EmployeeComponent />} />
        </Route>
        {/* Incentive CCA form section */}
        <Route path="/incentive-CCA/add" element={<PrivateRoute />}>
          <Route path="/incentive-CCA/add" element={<IncentiveCCA />} />
        </Route>
        {/* Incentive CCA Approval */}
        <Route path="/incentive-CCA/approval" element={<PrivateRoute />}>
          <Route
            path="/incentive-CCA/approval"
            element={<IncentiveCCAApproval />}
          />
        </Route>
        {/* Incentive CCA Statement */}
        <Route path="/incentive-CCA-statement" element={<PrivateRoute />}>
          <Route
            path="/incentive-CCA-statement"
            element={<IncentiveCCAStatement />}
          />
        </Route>
        <Route path="/my-tds-certificate" element={<PrivateRoute />}>
          <Route path="/my-tds-certificate" element={<MyTDSCertificate />} />
        </Route>

        {/* Employee Earning Report */}
        <Route path="/employee-earning-report" element={<PrivateRoute />}>
          <Route
            path="/employee-earning-report"
            element={<EmployeeEarningReport />}
          />
        </Route>

        {/* My Component */}
        <Route path="/my-components" element={<PrivateRoute />}>
          <Route path="/my-components" element={<MyComponent />} />
        </Route>
        {/* My IncrementComponent */}
        <Route path="/my-appraisal-components" element={<PrivateRoute />}>
          <Route path="/my-appraisal-components" element={<MyIncrementComponent />} />
        </Route>

        <Route path="/expense-settlement-statement" element={<PrivateRoute />}>
          <Route
            path="/expense-settlement-statement"
            element={<ExpenseSettlementStatement />}
          />
        </Route>
        {/* Payroll section end */}
        {/* leave ledger */}
        <Route path="/leave-ledger" element={<PrivateRoute />}>
          <Route path="/leave-ledger" element={<LeaveLedger />} />
        </Route>
        {/* Comp Off */}
        <Route path="/apply-comp-off" element={<PrivateRoute />}>
          <Route path="/apply-comp-off" element={<ApplyCompOff />} />
        </Route>
        <Route path="/apply-comp-off/edit" element={<PrivateRoute />}>
          <Route path="/apply-comp-off/edit" element={<EditCompOff />} />
        </Route>
        <Route path="/apply-comp-off/edit/:id" element={<PrivateRoute />}>
          <Route path="/apply-comp-off/edit/:id" element={<EditCompOff />} />
        </Route>
        <Route path="/approve-comp-off" element={<PrivateRoute />}>
          <Route path="/approve-comp-off" element={<ApprovalCompOff />} />
        </Route>
        <Route path="/apply-comp-off/view" element={<PrivateRoute />}>
          <Route path="/apply-comp-off/view" element={<ViewCompOff />} />
        </Route>
        <Route path="/apply-comp-off/view/:id" element={<PrivateRoute />}>
          <Route path="/apply-comp-off/view/:id" element={<ViewCompOff />} />
        </Route>
        <Route path="/comp-off-history-report" element={<PrivateRoute />}>
          <Route
            path="/comp-off-history-report"
            element={<CompOffHistroryReport />}
          />
        </Route>
        <Route path="/comp-off-statement" element={<PrivateRoute />}>
          <Route path="/comp-off-statement" element={<CompOffStatement />} />
        </Route>
        {/* Maternity Leave */}
        <Route path="/maternityLeave" element={<PrivateRoute />}>
          <Route path="/maternityLeave" element={<MaternityLeave />} />
        </Route>
        {/* Holiday Calender */}
        <Route path="/holiday-calender" element={<PrivateRoute />}>
          <Route path="/holiday-calender" element={<HolidayCalender />} />
        </Route>
        <Route
          path="/508811801950498069541140464195090/:emp_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/508811801950498069541140464195090/:emp_id"
            element={<EditBirthdayCard />}
          />
        </Route>
        <Route path="/work-anniversary" element={<PrivateRoute />}>
          <Route path="/work-anniversary" element={<Anniversary />} />
        </Route>
        <Route path="/hr-policies" element={<PrivateRoute />}>
          <Route path="/hr-policies" element={<HRPolicies />} />
        </Route>
        <Route
          path="/50881180195049ASDKSJAJDJDADJ/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/50881180195049ASDKSJAJDJDADJ/:id"
            element={<ManagerRemark />}
          />
        </Route>
        <Route
          path="/50881180195049ASDKSJAJDJDADJAJDJDKLL/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/50881180195049ASDKSJAJDJDADJAJDJDKLL/:id"
            element={<EmployeeRemark />}
          />
        </Route>
        <Route path="/shift" element={<PrivateRoute />}>
          <Route path="/shift" element={<Shift />} />
        </Route>
        <Route path="/hrCalendar" element={<PrivateRoute />}>
          <Route path="/hrCalendar" element={<HRCalender />} />
        </Route>
        <Route path="/hrCalendar/add" element={<PrivateRoute />}>
          <Route path="/hrCalendar/add" element={<HRCalenderForm />} />
        </Route>
        <Route path="/hrCalendar/edit/:id" element={<PrivateRoute />}>
          <Route path="/hrCalendar/edit/:id" element={<CalenderEdit />} />
        </Route>
        <Route path="/department" element={<PrivateRoute />}>
          <Route path="/department" element={<Department />} />
        </Route>
        <Route path="/designation" element={<PrivateRoute />}>
          <Route path="/designation" element={<Designation />} />
        </Route>
        <Route path="/feedback-submitted" element={<PrivateRoute />}>
          <Route path="/feedback-submitted" element={<FeedbackSubmitted />} />
        </Route>
        <Route path="/interview-staus-report" element={<PrivateRoute />}>
          <Route
            path="/interview-staus-report"
            element={<InterviewStatusReport />}
          />
        </Route>
        <Route path="/leave-approves" element={<PrivateRoute />}>
          <Route path="/leave-approves" element={<LeaveApproves />} />
        </Route>
        {/* rom report */}
        <Route path="/bench-tracker-report" element={<PrivateRoute />}>
          <Route
            path="/bench-tracker-report"
            element={<BenchTrackerReport />}
          />
        </Route>
          <Route path="/revenue-by-resource" element={<PrivateRoute />}>
            <Route path="/revenue-by-resource" element={<RevenueByResource />} />
          </Route>
          <Route path="/requirement-tracker-report" element={<PrivateRoute />}>
            <Route path="/requirement-tracker-report" element={<TAReport />} />
          </Route>
        {/* demo section start 12-Aug-2024 */}
        {/* <Route path="/demo" element={<PrivateRoute />}>
          <Route path="/demo" element={<Demo />} />
        </Route> */}
        {/* demo section end 12-Aug-2024 */}
        <Route path="/on-bench-project-report" element={<PrivateRoute />}>
          <Route
            path="/on-bench-project-report"
            element={<OnBenchProjectReport />}
          />
        </Route>
        <Route path="/due-extension-report" element={<PrivateRoute />}>
          <Route
            path="/due-extension-report"
            element={<DueExtensionReport />}
          />
        </Route>
        <Route path="/Kpi-summary" element={<PrivateRoute />}>
          <Route path="/Kpi-summary" element={<KpiSummary />} />
        </Route>
        <Route path="/master-report" element={<PrivateRoute />}>
          <Route path="/master-report" element={<MasterReport />} />
        </Route>
        <Route path="/customer-contact-report" element={<PrivateRoute />}>
          <Route
            path="/customer-contact-report"
            element={<CustomerContactReport />}
          />
        </Route>
        <Route path="/skillset-matrix-report" element={<PrivateRoute />}>
          <Route
            path="/skillset-matrix-report"
            element={<SkillSetMatrixReport />}
          />
        </Route>
        <Route path="/resource-report" element={<PrivateRoute />}>
          <Route path="/resource-report" element={<ResourceReport />} />
        </Route>
        <Route path="/kpi-report" element={<PrivateRoute />}>
          <Route path="/kpi-report" element={<KpiReport />} />
        </Route>
        <Route path="/employee-cost" element={<PrivateRoute />}>
          <Route path="/employee-cost" element={<EmployeeCost />} />
        </Route>
        <Route path="/employee-master-report" element={<PrivateRoute />}>
          <Route
            path="/employee-master-report"
            element={<EmployeeMasterReport />}
          />
        </Route>
        <Route path="/non-billable-employee" element={<PrivateRoute />}>
          <Route
            path="/non-billable-employee"
            element={<NonBillableemployee />}
          />
        </Route>
        <Route
          path="/view-job-description/:JobDescriptionID"
          element={<PrivateRoute />}
        >
          <Route
            path="/view-job-description/:JobDescriptionID"
            element={<ViewJobDescription />}
          />
        </Route>
        <Route path="/employee-list" element={<PrivateRoute />}>
          <Route path="/employee-list" element={<EmployeeList />} />
        </Route>
        <Route path="/employee/history" element={<PrivateRoute />}>
          <Route
            path="/employee/history"
            element={<EmployeeHistorylist />}
          />
        </Route>
        <Route path="/employee/history/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/employee/history/edit/:id"
            element={<EmployeeHistoryEdit />}
          />
        </Route>
        <Route path="/RMG/employees" element={<PrivateRoute />}>
          <Route path="/RMG/employees" element={<RMGKPIEmpList />} />
        </Route>
        <Route path="/RMG/sub-contractors" element={<PrivateRoute />}>
          <Route
            path="/RMG/sub-contractors"
            element={<RMGSubcontractorList />}
          />
        </Route>
        <Route path="/RMG/employees/view/:id" element={<PrivateRoute />}>
          <Route path="/RMG/employees/view/:id" element={<RMGEmployeeView />} />
        </Route>

        <Route
          path="/employee-list/EmployeePayrolls/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/employee-list/EmployeePayrolls/edit/:id"
            element={<EmployeePayrolls />}
          />
        </Route>
        <Route path="/employee-list/rujul/add" element={<PrivateRoute />}>
          <Route path="/employee-list/rujul/add" element={<EmployeeAdd />} />
        </Route>
        <Route path="/employee-list/rujul/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/employee-list/rujul/edit/:id"
            element={<EmployeeEdit />}
          />
        </Route>
        <Route path="/employee-list/rujul/view/:id" element={<PrivateRoute />}>
          <Route
            path="/employee-list/rujul/view/:id"
            element={<EmployeeView />}
          />
        </Route>
        {/* <Route path="/candidate-details" element={<PrivateRoute />}>
          <Route path="/candidate-details" element={<CandidateDetails />} />
        </Route> */}
        {/* <Route path="/details-submitted" element={<ExternalRoute />}>
          <Route
            path="/details-submitted"
            element={<ThankYouPageCandidate />}
          />
        </Route> */}
        {/* <Route path="/link-expired" element={<ExternalRoute />}>
          <Route path="/link-expired" element={<LinkExpired />} />
        </Route> */}
        <Route path="/banks" element={<PrivateRoute />}>
          <Route path="/banks" element={<BankList />} />
        </Route>
        <Route path="/add-bank" element={<PrivateRoute />}>
          <Route path="/add-bank" element={<AddBank />} />
        </Route>
        <Route path="/edit-bank/:id" element={<PrivateRoute />}>
          <Route path="/edit-bank/:id" element={<AddBank />} />
        </Route>
        <Route
          path="/candidate-details-verify/:candidate_line_up_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/candidate-details-verify/:candidate_line_up_id"
            element={<VerifyCandidateDetails />}
          />
        </Route>
        <Route
          path="/candidate-details-ta-verify/:candidate_line_up_id"
          element={<PrivateRoute />}
        >
          <Route
            path="/candidate-details-ta-verify/:candidate_line_up_id"
            element={<TAVerifyCandidateDetails />}
          />
        </Route>

        {/* Organization Module Routes Start Here*/}
        <Route path="/admin/employee-details-report" element={<PrivateRoute />}>
          <Route
            path="/admin/employee-details-report"
            element={<EmployeeDetailsReport />}
          />
        </Route>
        <Route path="/organization-chart" element={<PrivateRoute />}>
          <Route path="/organization-chart" element={<OrganizationChart />} />
        </Route>
        <Route path="/announcements" element={<PrivateRoute />}>
          <Route path="/announcements" element={<Announcements />} />
        </Route>
        <Route path="/awards" element={<PrivateRoute />}>
          <Route path="/awards" element={<AwardList />} />
        </Route>
        <Route path="/awards/add" element={<PrivateRoute />}>
          <Route path="/awards/add" element={<AwardForm />} />
        </Route>
        <Route path="/awards/edit/:id" element={<PrivateRoute />}>
          <Route path="/awards/edit/:id" element={<AwardEditForm />} />
        </Route>
        <Route path="/admin/monthly-report" element={<PrivateRoute />}>
          <Route path="/admin/monthly-report" element={<MonthlyReport />} />
        </Route>
        <Route path="/knowledge-base" element={<PrivateRoute />}>
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
        </Route>
        <Route path="/admin/knowledge-base" element={<PrivateRoute />}>
          <Route
            path="/admin/knowledge-base"
            element={<KnowledgeBaseAdmin />}
          />
        </Route>
        <Route path="/admin/announce-events" element={<PrivateRoute />}>
          <Route
            path="/admin/announce-events"
            element={<PostWhatsNewForthcoming />}
          />
        </Route>
        {/* Organization Module Routes End Here*/}
        {/* Support Desk Module Routes Start Here */}
        <Route path="/asset-category" element={<PrivateRoute />}>
          <Route path="/asset-category" element={<AssetCategory />} />
        </Route>
        <Route path="/asset-category/add" element={<PrivateRoute />}>
          <Route path="/asset-category/add" element={<AssetCategoryForm />} />
        </Route>
        <Route path="/model-master" element={<PrivateRoute />}>
          <Route path="/model-master" element={<ModelMasters />} />
        </Route>
        <Route path="/asset-category/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/asset-category/edit/:id"
            element={<AssetCategoryForm />}
          />
        </Route>
        {/* <Route path="/model-masters" element={<PrivateRoute />}>
          <Route path="/model-masters" element={<ModelMasters />} />
        </Route> */}
        <Route path="/model-master/add" element={<PrivateRoute />}>
          <Route path="/model-master/add" element={<ModelMasterAdd />} />
        </Route>
        <Route path="/model-master/edit/:id" element={<PrivateRoute />}>
          <Route path="/model-master/edit/:id" element={<ModelMasterEdit />} />
        </Route>
        <Route path="/upcoming-joiners" element={<PrivateRoute />}>
          <Route path="/upcoming-joiners" element={<UpcomingJoineer />} />
        </Route>
        <Route path="/vendor-master" element={<PrivateRoute />}>
          <Route path="/vendor-master" element={<VendorMasterList />} />
        </Route>
        <Route path="/vendor-master/add" element={<PrivateRoute />}>
          <Route path="/vendor-master/add" element={<VendorMasterAdd />} />
        </Route>
        <Route path="/vendor-master/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/vendor-master/edit/:id"
            element={<VendorMasterEdit />}
          />
        </Route>
        <Route path="/asset-return" element={<PrivateRoute />}>
          <Route path="/asset-return" element={<AssetReturnList />} />
        </Route>
        <Route path="/asset-return/add" element={<PrivateRoute />}>
          <Route path="/asset-return/add" element={<AssetReturnAdd />} />
        </Route>
        <Route path="/disposed-of-asset-report" element={<PrivateRoute />}>
          <Route
            path="/disposed-of-asset-report"
            element={<DisposedOfAssetReport />}
          />
        </Route>
        <Route path="/asset-allocation" element={<PrivateRoute />}>
          <Route path="/asset-allocation" element={<AssetAllocationList />} />
        </Route>
        <Route path="/asset-allocation/add" element={<PrivateRoute />}>
          <Route
            path="/asset-allocation/add"
            element={<AssetAllocationAdd />}
          />
        </Route>
        <Route path="/asset-allocation/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/asset-allocation/edit/:id"
            element={<AssetAllocationEdit />}
          />
        </Route>
        <Route path="/repairable-assets" element={<PrivateRoute />}>
          <Route path="/repairable-assets" element={<RepairableAssetsList />} />
        </Route>
        <Route path="/repairable-assets/add/:id" element={<PrivateRoute />}>
          <Route
            path="/repairable-assets/add/:id"
            element={<RepairableAssetAdd />}
          />
        </Route>
        <Route path="/repairable-assets/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/repairable-assets/edit/:id"
            element={<RepairableAssetEdit />}
          />
        </Route>
        <Route path="/summary-report-it-report" element={<PrivateRoute />}>
          <Route
            path="/summary-report-it-report"
            element={<SummaryReportITReport />}
          />
        </Route>
        <Route path="/master-report-it-assets" element={<PrivateRoute />}>
          <Route
            path="/master-report-it-assets"
            element={<MasterReportITAssets />}
          />
        </Route>
        <Route path="/obsolete-assets" element={<PrivateRoute />}>
          <Route path="/obsolete-assets" element={<ObsoleteAssets />} />
        </Route>
        <Route path="/purchase-summary" element={<PrivateRoute />}>
          <Route path="/purchase-summary" element={<PurchaseSummary />} />
        </Route>
        <Route path="/subscription-summary" element={<PrivateRoute />}>
          <Route
            path="/subscription-summary"
            element={<SubscriptionSummary />}
          />
        </Route>
        <Route path="/asset-return-statement" element={<PrivateRoute />}>
          <Route
            path="/asset-return-statement"
            element={<AssetReturnStatement />}
          />
        </Route>
        <Route path="/asset-allocation-details" element={<PrivateRoute />}>
          <Route
            path="/asset-allocation-details"
            element={<AssetAllocationDetails />}
          />
        </Route>
        <Route path="/add-asset" element={<PrivateRoute />}>
          <Route path="/add-asset" element={<AddAssetList />} />
        </Route>
        <Route path="/add-asset/import" element={<PrivateRoute />}>
          <Route path="/add-asset/import" element={<ImportAsset />} />
        </Route>
        <Route path="/add-asset/add" element={<PrivateRoute />}>
          <Route path="/add-asset/add" element={<AddAssetForm />} />
        </Route>
        <Route path="/add-asset/edit/:id" element={<PrivateRoute />}>
          <Route path="/add-asset/edit/:id" element={<EditAssetForm />} />
        </Route>
        <Route path="/add-asset/history/:id" element={<PrivateRoute />}>
          <Route path="/add-asset/history/:id" element={<AssetHistory />} />
        </Route>
        /** Laptop Maintaince  */
        <Route path="/asset-maintenance-listing" element={<PrivateRoute />}>
          <Route path="/asset-maintenance-listing" element={<AssetMaintenanceListing />} />
        </Route>
        <Route path="/admin/tickets" element={<PrivateRoute />}>
          <Route path="/admin/tickets" element={<EmployeeAdminList />} />
        </Route>
        <Route path="/admin/tickets/add" element={<PrivateRoute />}>
          <Route path="/admin/tickets/add" element={<EmployeeAdminAddForm />} />
        </Route>
        <Route path="/admin/tickets/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/admin/tickets/edit/:id"
            element={<EmployeeAdminEditForm />}
          />
        </Route>
        <Route path="/manage/admin/tickets" element={<PrivateRoute />}>
          <Route path="/manage/admin/tickets" element={<SuperAdminList />} />
        </Route>
         <Route path="/category-designation/add" element={<PrivateRoute />}>
          <Route path="/category-designation/add" element={<CategoryDesignationForm />} />
        </Route>
        <Route path="/category-designation" element={<PrivateRoute />}>
          <Route path="/category-designation" element={<PRCategoryDesignation />} />
        </Route>
        <Route path="/pr-designation-category" element={<PrivateRoute />}>
          <Route path="/pr-designation-category" element={<PRDesignationCategory />} />
        </Route>
        
        <Route path="/requisition-approval" element={<PrivateRoute />}>
          <Route
            path="/requisition-approval"
            element={<RequisitionApproval />}
          />
        </Route>
        <Route path="/admin/IT/support/tickets" element={<PrivateRoute />}>
          <Route
            path="/admin/IT/support/tickets"
            element={<SuperITSupportTicketList />}
          />
        </Route>
        <Route path="/IT/support/tickets/add" element={<PrivateRoute />}>
          <Route
            path="/IT/support/tickets/add"
            element={<EmployeeITSupportTicketAddForm />}
          />
        </Route>
        <Route path="/IT/support/tickets" element={<PrivateRoute />}>
          <Route
            path="/IT/support/tickets"
            element={<EmployeeITSupportTicketList />}
          />
        </Route>
        <Route path="/IT/support/tickets/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/IT/support/tickets/edit/:id"
            element={<EmployeeITSupportTicketEditForm />}
          />
        </Route>
        {/* Support Desk Module Routes End Here */}

        {/** Rujul Routes*/}
        <Route path="/roles" element={<PrivateRoute />}>
          <Route path="/roles" element={<RoleList />} />
        </Route>
        <Route path="/roles/add" element={<PrivateRoute />}>
          <Route path="/roles/add" element={<AddRole />} />
        </Route>
        <Route path="/roles/edit/:role_id" element={<PrivateRoute />}>
          <Route path="/roles/edit/:role_id" element={<EditRole />} />
        </Route>
        {/* <Route path="/rujul/user-list" element={<PrivateRoute />}>
          <Route path="/rujul/user-list" element={<UserList />} />
        </Route>
        <Route path="/rujul/user/add" element={<PrivateRoute />}>
          <Route path="/rujul/user/add" element={<UserAdd />} />
        </Route>
        <Route path="/rujul/user/edit/:id" element={<PrivateRoute />}>
          <Route path="/rujul/user/edit/:id" element={<UserEdit />} />
        </Route> */}

        <Route path="/rujul/user-list/add" element={<PrivateRoute />}>
          <Route path="/rujul/user-list/add" element={<UserRegistration />} />
        </Route>
        <Route path="/rujul/user-list" element={<PrivateRoute />}>
          <Route path="/rujul/user-list" element={<UserList />} />
        </Route>
        <Route path="/rujul/user-list/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/rujul/user-list/edit/:id"
            element={<UserRegisterationEdit />}
          />
        </Route>

        <Route path="/rujul/hrm/payroll" element={<PrivateRoute />}>
          <Route path="/rujul/hrm/payroll" element={<PayrollListing />} />
        </Route>
        <Route path="/rujul/hrm/payroll-statement" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/payroll-statement"
            element={<PayrollStatement />}
          />
        </Route>
        <Route path="/rujul/hrm/payroll/add" element={<PrivateRoute />}>
          <Route path="/rujul/hrm/payroll/add" element={<PayrollAdd />} />
        </Route>
        <Route path="/rujul/hrm/payroll/edit/:id" element={<PrivateRoute />}>
          <Route path="/rujul/hrm/payroll/edit/:id" element={<PayrollEdit />} />
        </Route>
        <Route path="/rujul/hrm/payroll-scales" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/payroll-scales"
            element={<PayrollScalesList />}
          />
          a
        </Route>
        <Route path="/rujul/hrm/payroll-scales/add" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/payroll-scales/add"
            element={<PayrollScalesAdd />}
          />
        </Route>
        <Route
          path="/rujul/hrm/payroll-scales/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/payroll-scales/edit/:id"
            element={<PayrollScalesEdit />}
          />
        </Route>
        <Route path="/rujul/hrm/it-declaration" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/it-declaration"
            element={<ITDeclarationList />}
          />
        </Route>
        <Route path="/rujul/hrm/it-declaration/add" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/it-declaration/add"
            element={<ITDeclarationAdd />}
          />
        </Route>
        <Route
          path="/rujul/hrm/it-declaration/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/it-declaration/edit/:id"
            element={<ITDeclarationEdit />}
          />
        </Route>
        <Route
          path="/rujul/hrm/employee-it-declaration/list"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/employee-it-declaration/list"
            element={<EmployeeITDeclarations />}
          />
        </Route>
        <Route
          path="/rujul/hrm/employee-payroll-increment"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/employee-payroll-increment"
            element={<EmployeePayrollIncrement />}
          />
        </Route>
        <Route path="/rujul/hrm/calculate-payroll" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/calculate-payroll"
            element={<CalculatePayroll />}
          />
        </Route>
        <Route
          path="/rujul/hrm/confirmation-payroll"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/confirmation-payroll"
            element={<ConfirmationPayroll />}
          />
        </Route>

        <Route path="/rujul/hrm/attendance-book" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/attendance-book"
            element={<AttendanceBookRujul />}
          />
        </Route>
        <Route
          path="/rujul/hrm/attendance-book-statement"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/attendance-book-statement"
            element={<AttendanceBookStatement />}
          />
        </Route>
        <Route path="/rujul/hrm/income-tax-slab/add" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/income-tax-slab/add"
            element={<IncomeTaxSlabAdd />}
          />
        </Route>
        <Route path="/rujul/hrm/income-tax-slab/edit/:id" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/income-tax-slab/edit/:id"
            element={<IncomeTaxSlabEdit />}
          />
        </Route>
        <Route path="/rujul/hrm/income-tax-slab" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/income-tax-slab"
            element={<IncomeTaxSlabList />}
          />
        </Route>
        <Route
          path="/company-financial-month"
          element={<PrivateRoute />}
        >
          <Route
            path="/company-financial-month"
            element={<CompanyFinancialMonth />}
          />
        </Route>
        <Route
          path="/rujul/hrm/attendance-book-approval"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/attendance-book-approval"
            element={<AttendanceBookApproval />}
          />
        </Route>
        <Route path="/rujul/hrm/print-email-payslip" element={<PrivateRoute />}>
          <Route
            path="/rujul/hrm/print-email-payslip"
            element={<PrintEmailPaySlip />}
          />
        </Route>
        <Route
          path="/rujul/hrm/print-email-payslip/payment-slip/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/print-email-payslip/payment-slip/:id"
            element={<PaymentSlip />}
          />
        </Route>
        <Route
          path="/rujul/hrm/generate-payroll-advice"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/hrm/generate-payroll-advice"
            element={<GeneratePayrollAdvice />}
          />
        </Route>

        {/* rujul General Master */}
        <Route path="/rujul/admin/general-master" element={<PrivateRoute />}>
          <Route
            path="/rujul/admin/general-master"
            element={<GeneralMaster />}
          />
        </Route>
        <Route
          path="/rujul/admin/general-master/add"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/admin/general-master/add"
            element={<GeneralMasterAdd />}
          />
        </Route>
        <Route
          path="/rujul/admin/general-master/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/admin/general-master/edit/:id"
            element={<GeneralMasterEdit />}
          />
        </Route>
        <Route
          path="/rujul/admin/general-master/view/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/admin/general-master/view/:id"
            element={<GeneralMasterView />}
          />
        </Route>

        {/* Rujul Object Type */}
        <Route path="/rujul/admin/object-type" element={<PrivateRoute />}>
          <Route path="/rujul/admin/object-type" element={<ObjectTypeList />} />
        </Route>
        <Route path="/rujul/admin/object-type/add" element={<PrivateRoute />}>
          <Route path="/rujul/admin/object-type/add" element={<ObjectType />} />
        </Route>

        <Route
          path="/rujul/admin/object-type/edit/:id"
          element={<PrivateRoute />}
        >
          <Route
            path="/rujul/admin/object-type/edit/:id"
            element={<ObjectTypeEdit />}
          />
        </Route>
        <Route path="/" element={<PrivateRoute />}></Route>
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </ProtectedRoute>
      {/* <ToastContainer
        autoClose={3000}
        draggable={false}
        position="top-right"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
      /> */}
    </>
  );
};

export default App;
